import utils from '@/js/utils/util.js';
import { resolve } from 'core-js/fn/promise';
var pageUtils = {

    /**
     * 对Date的扩展，将 Date 转化为指定格式的String
     * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
     * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
     * 例子：
     * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
     * (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
     * @param {*} fmt
     */
    dateFormat : function (onedate,fmt) { //author: meizz
        var o = {
            "M+": onedate.getMonth() + 1, //月份
            "d+": onedate.getDate(), //日
            "h+": onedate.getHours(), //小时
            "H+": onedate.getHours(), //小时
            "m+": onedate.getMinutes(), //分
            "s+": onedate.getSeconds(), //秒
            "q+": Math.floor((onedate.getMonth() + 3) / 3), //季度
            "S": onedate.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (onedate.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },
    //秒 转为时分秒  （暂时题库组件和题库倒计时中使用）
    formatSeconds: function(value) {
        var secondTime = parseInt(value);// 秒
        var minuteTime = 0;// 分
        var hourTime = 0;// 小时
        if(secondTime < 0) {
            secondTime = 0;
        }
        if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取佘，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if(minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        var result = (parseInt(secondTime)<10?"0":"") + parseInt(secondTime) + "";

        if(minuteTime > 0) {
            result = (parseInt(minuteTime)<10?"0":"") + parseInt(minuteTime) + ":" + result;
        } else {
            result = "00:" + result;
        }
        if(hourTime > 0) {
            result = hourTime + parseInt(hourTime) + ":" + result;
        } else {
            result = "00:" + result;
        }
        return result;
    },

    /**
     * 将一维的扁平数组转换为多层级对象
     * @param  {[type]} list 一维数组，数组中每一个元素需包含id和parent_id两个属性
     * @return {[type]} tree 多层级树状结构
     * (对应小程序方法在 utils下边)
     */
    buildTree : function(list){
        let temp = {};
        let tree = [];
        var keyList = [];
        for(let i in list){
            if(!list[i].id) {
                if(list[i].LMF_ID) {
                    list[i].id =  list[i].LMF_ID;
                } else {
                    list[i].id =  list[i].ID;
                }
            }
            if(!list[i].pId) {
                list[i].pId =  list[i].PID;
            }
            if(!list[i].name) {
                list[i].name =  list[i].NAME;
            }
            if(!list[i].mate && list[i].MATE) {
                list[i].mate = {
                    name:list[i].MATE
                }
            }
            list[i].list_index = i*1;
            temp[list[i].id] = list[i];
            keyList.push(list[i].id);
        }
        keyList.forEach(i => {
            if(temp[i].pId) {
                if(!temp[temp[i].pId]) {
                    temp[i].now_index = tree.length;
                    tree.push(temp[i]);
                } else {
                    if(!temp[temp[i].pId].children) {
                        temp[temp[i].pId].children = [];
                    }
                    temp[i].now_index = temp[temp[i].pId].children.length;
                    temp[i].parent_index = temp[temp[i].pId].now_index;
                    temp[temp[i].pId].children.push(temp[i]);
                }
            } else {
                temp[i].now_index = tree.length;
                tree.push(temp[i]);
            }
        });
        return tree;
    },

    /**
     * 进行搜索条件的初始化 为点击搜索后台条件 form表单数据做准备
     * （暂时只有报表中使用了，对应小程序中没有此方法）
     */
    initToHtSearchData : function(that) {
        var toHtSearchData = {
            freeTimeSearchArr:[{
                freeTime_6_andOr:1,
                startDate_startDates_pld:'',
                endDate_endDates_pld:'',
                startTime_startDates_pld:'',
                endTime_endDates_pld:'',
                startWeek_startDates_pld:-1,
                endWeek_startDates_pld:-1
            }]
        };//that.$refs.ListSearch.toHtSearchData;
        that.searchSetArr.forEach(element => {
            //字段类型 为数字类型
            if(element.fieldType == 1 && element.chooseType != 2) {
                toHtSearchData[element.fieldAliasName+"_1_andOr"]=0;
                toHtSearchData[element.fieldAliasName+"_numCondOne_pld"]=2;
                toHtSearchData[element.fieldAliasName+"_numCondTwo_pld"]=2;
                toHtSearchData[element.fieldAliasName+"_numValOne_pld"]="";
                toHtSearchData[element.fieldAliasName+"_numValTwo_pld"]="";
            } else if(element.fieldType == 2) {
                //fieldType == 2 则为字符搜索条件  默认为包含 如果neglectLimitSearch = 1 则设置为全局等于
                toHtSearchData[element.fieldAliasName+"_2_andOr"]=0;
                if(element.neglectLimitSearch == 1) {
                    toHtSearchData[element.fieldAliasName+"_strCond_pld"]=6;
                } else {
                    toHtSearchData[element.fieldAliasName+"_strCond_pld"]=0;
                }
                toHtSearchData[element.fieldAliasName+"_strVal_pld"]="";
            }  else if(element.fieldType == 4 || (element.fieldType == 1 && element.chooseType == 2)) {
                //fieldType == 4 则为数据字典搜索条件
                toHtSearchData[element.fieldAliasName+"_d_andOr"]=0;
                toHtSearchData[element.fieldAliasName+"_d_dicCond_pld"]=0;
                toHtSearchData[element.fieldAliasName+"strCond_dic"]=[];
            } else if(element.fieldType == 3) {
                toHtSearchData[element.fieldAliasName+"_3_andOr"]=0;
                if(element.dateType == null) {
                    element.dateType = "yyyy-MM-dd"
                }
                toHtSearchData[element.fieldAliasName+"_dateType"]=element.dateType;
                if(element.dateType.indexOf(":")>=0) {
                    toHtSearchData[element.fieldAliasName+"_type"]="datetime";
                } else if(element.dateType == "yyyy-MM") {
                    toHtSearchData[element.fieldAliasName+"_type"]="month";
                } else if(element.dateType == "yyyy") {
                    toHtSearchData[element.fieldAliasName+"_type"]="year";
                } else {
                    toHtSearchData[element.fieldAliasName+"_type"]="date";
                }
                //判断是否有默认选中值  defDateRange
                if(element.defDateRange == 1) {//本月
                    var startDefDate = new Date();
                    startDefDate.setDate(1);
                    var endDefDate = new Date();
                    endDefDate.setMonth(endDefDate.getMonth()+1);
                    endDefDate.setDate(0);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 2) {//本周
                    var weekDay = new Date().getDay();
                    var monthDate = new Date().getDate();
                    var startDefDate = new Date();
                    startDefDate.setDate(monthDate - weekDay + 1);
                    var endDefDate = new Date();
                    endDefDate.setDate(monthDate - weekDay + 7);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 3) {//与当前相差天数 betweenDay
                    var startDefDate = new Date();
                    var endDefDate = new Date();
                    endDefDate.setDate(endDefDate.getDate()+element.betweenDay);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 4) {//本年
                    var startDefDate = new Date();
                    startDefDate.setMonth(0);
                    startDefDate.setDate(1);
                    var endDefDate = new Date();
                    endDefDate.setFullYear(endDefDate.getFullYear()+1);
                    endDefDate.setMonth(0);
                    endDefDate.setDate(0);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 5) {//昨天
                    var startDefDate = new Date();
                    startDefDate.setDate(startDefDate.getDate()-1);
                    var endDefDate = new Date();
                    endDefDate.setDate(endDefDate.getDate()-1);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 6) {//上周
                    var weekDay = new Date().getDay();
                    var monthDate = new Date().getDate();
                    var startDefDate = new Date();
                    startDefDate.setDate(monthDate - weekDay - 6);
                    var endDefDate = new Date();
                    endDefDate.setDate(monthDate - weekDay);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 7) {//上月
                    var startDefDate = new Date();
                    startDefDate.setMonth(startDefDate.getMonth()-1);
                    startDefDate.setDate(1);
                    var endDefDate = new Date();
                    endDefDate.setDate(0);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 8) {//去年
                    var startDefDate = new Date();
                    startDefDate.setFullYear(startDefDate.getFullYear()-1);
                    startDefDate.setMonth(0);
                    startDefDate.setDate(1);
                    var endDefDate = new Date();
                    endDefDate.setMonth(0);
                    endDefDate.setDate(0);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 9) {//上季度
                    var yearMonth = new Date().getMonth();
                    var startMonth = (yearMonth/3).toFixed(0)*3-3;
                    var endMonth = (yearMonth/3).toFixed(0)*3;
                    var startDefDate = new Date();
                    startDefDate.setMonth(startMonth);
                    startDefDate.setDate(1);
                    var endDefDate = new Date();
                    endDefDate.setMonth(endMonth);
                    endDefDate.setDate(0);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else if(element.defDateRange == 10) {//本季度
                    var yearMonth = new Date().getMonth();
                    var startMonth = 0+(yearMonth/3).toFixed(0)*3;
                    var endMonth = 3+(yearMonth/3).toFixed(0)*3;
                    var startDefDate = new Date();
                    startDefDate.setMonth(startMonth);
                    startDefDate.setDate(1);
                    var endDefDate = new Date();
                    endDefDate.setMonth(endMonth);
                    endDefDate.setDate(0);
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]=this.dateFormat(startDefDate,element.dateType);
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]=this.dateFormat(endDefDate,element.dateType);
                } else {
                    toHtSearchData[element.fieldAliasName+"_startDates_pld"]="";
                    toHtSearchData[element.fieldAliasName+"_endDates_pld"]="";
                }
            }
        });
        // console.log("toHtSearchData==============================",toHtSearchData);
        return toHtSearchData;
    },
    //日期加减 (暂时没有用到)
    addDate:function(dd,dadd,fmt){
        var a = new Date(dd)
        a = a.valueOf();
        a = a + dadd * 24 * 60 * 60 * 1000;
        a = new Date(a);
        return this.dateFormat(a,fmt==null || fmt==undefined?'yyyy-MM-dd':fmt);
    },
    /**
     * 跳转到登录页面
     * (MainPage页面使用 小程序中暂时未使用此方法)
     */
    toLoginPage:function(that){
        that.$router.push({ 
            name: 'LoginPage', 
            params: {
            }
        });
    },
    /*
    * 加载列表页面设置信息 
    */
    loadListPageSet: function (that, callBack) {
        var toHtData = {};
        var tableId = that.tableId;
        var pageId = that.pageId;
        var mainId = that.mainId;
        toHtData.tableId = tableId;
        toHtData.pageId = pageId;
        toHtData.mainId = mainId;
        that.isLoading = true;
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
            url: 'wxXcxSet_interfaceToList.do', //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
                that.isLoading = false;
                if (res.data != null) {
                    callBack(res.data,that);
                } else {
                // 页面不存在
                    that.$notify.error({
                        title: '错误',
                        message: '页面不存在',
                        duration: 2000
                    });
                }
            }
        })
    },
    /**
     * 加载添加修改查看页面的设置信息 
     */
    loadAUPageSet:function(that,callBack){
        var tableId = that.tableId;
        var pageId = that.pageId;
        var pageType = that.pageType;
        //列表的tableId
        var mainTableId = that.listTableId;
        //如果是关联添加或者 修改 数据的主键id
        var mainId = that.mainId;
        var toHtData = {};
        toHtData.tableId = tableId;
        toHtData.pageId = pageId;
        if (pageType == 11) {
            toHtData.pageType = 7;
        } else {
            toHtData.pageType = pageType;
        }
        toHtData.mainId = mainId;
        toHtData.mainTableId = mainTableId;
        that.isLoading = true;
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
            url: 'wxXcxSet_interfaceToAdd.do', //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
                that.isLoading = false;
                if (res.data != null) {
                    callBack(res.data,that)
                } else {
                    // 页面不存在
                    that.$notify.error({
                        title: '错误',
                        message: '页面不存在',
                        duration: 2000
                    });
                }
            }
        })
    },
    /**
     * 进行修改页面的数据处理 便于进行数据显示
     * 把pageSet 和 dataInfo 进行数据整合 便于页面的显示
     */
    initToUpdateField:function(fieldSet, dataInfo, that, prevDateIndex, dialogTableId,pageSetInfo){
        var firstNameValue = "";
        var maxRowColJson = that.maxRowColJson;

        for (var i = 0; i < fieldSet.length; i++) {
            var oneField = fieldSet[i];
            if(!oneField.styleSet) {
                oneField.styleSet = {

                };
            }
            oneField.fieldIndex = i;   
            if(i+1<fieldSet.length) {
                var nextField = fieldSet[i+1];
                var middelIndex = (nextField.row*(maxRowColJson.maxCol+1)+nextField.col) - (oneField.row*(maxRowColJson.maxCol+1) + oneField.col) - oneField.colSpan;
                oneField.middelIndex = middelIndex<0?0:middelIndex;
            } else {
                oneField.middelIndex = 0;
            }
            var aliasName = oneField.fieldAliasName;
            var zdyAliasName = oneField.zdyAliasName;
            var relationTableId = oneField.relationTableId;
            var showFieldArr = oneField.showFieldArr;
            var childDialogTableId = oneField.dialogTableId;
            var dialogFieldAliasName = oneField.dialogFieldAliasName;
            var lmfValueFirstAliasName = oneField.lmfValueFirstAliasName;
            var inputFName = oneField.inputFName;
            var fieldRole = oneField.fieldRole;
            fieldRole = oneField.plugRole > 0 ? oneField.plugRole : fieldRole;
            
            this.loadFieldRulesByField(oneField,that);


            var aliasValue = dataInfo[aliasName];
            if (aliasName && aliasName != undefined && fieldRole != 20 && fieldRole != 22 && fieldRole != 24) {
                if (dialogTableId > 0 && dialogFieldAliasName && dialogFieldAliasName != undefined) {
                    aliasName = "F_" + dialogTableId + "_" + aliasName;

                }
                aliasValue = dataInfo[aliasName];
                // console.log("aliasValue=========================",oneField.fieldCnName,aliasValue);
                if (aliasValue != null && aliasValue != undefined) {
                    //展示类型 并且 展现形式是 文本域 
                    if (oneField.fieldType == 2) {
                    //字符类型 并且 展现形式是 文本域 
                    // if (oneField.showType == 1) {
                        if (typeof (aliasValue) == "string") {
                            if(aliasValue) {
                                aliasValue = aliasValue.replace(/_@/g, "\n");
                                dataInfo[aliasName] = aliasValue;
                            }
                        }
                    }

                    var dateType = oneField.dateType;
                    //为空是否显示默认值
                    var ifNullShowDefVal = oneField.ifNullShowDefVal;
                    //是否强制显示默认值
                    var ifShowDefVal = oneField.ifShowDefVal;
                    ifShowDefVal = isNaN(ifShowDefVal) ? 0 : ifShowDefVal;
                    ifNullShowDefVal = isNaN(ifNullShowDefVal) ? 0 : ifNullShowDefVal;
                    if (dateType && dateType != "") {
                        //如果是日期类型进行截取
                        if (aliasValue != null && (aliasValue + "").indexOf("-") >= 0) {
                            aliasValue = aliasValue.replace(/-/g, '/');
                        }
                        var date = new Date(aliasValue);
                        oneField.defaultValStr = this.dateFormat(date, dateType);
                    } else if (fieldRole == 16 || fieldRole == 17 || fieldRole == 23) {
                        if (fieldRole == 17) {
                            inputFName = inputFName.substring(0, inputFName.lastIndexOf("_"));
                            aliasValue = dataInfo[inputFName + "_dicSql"];
                        }
                        //数据字典类型
                        var dicParId = oneField.dicParId;
                        if (ifShowDefVal == 0 && (ifNullShowDefVal == 0 || aliasValue != null)) {
                            oneField.defaultCheckValue = (fieldRole == 16?aliasValue*1:aliasValue);
                            oneField.defaultValStr = (fieldRole == 16?oneField.defaultCheckValue*1:oneField.defaultCheckValue);
                        }
                        utils.dicDefaultCheck(oneField, (fieldRole == 16?oneField.defaultCheckValue*1:oneField.defaultCheckValue));
                        oneField.defaultValStr = oneField.defaultCheckCnName;
                    } else if (fieldRole == 19) {
                        
                    } else {
                        if(ifShowDefVal == 1 && oneField.defaultValStr != null && oneField.defaultValStr != "") {
                            //不进行数据赋值
                        } else if(ifNullShowDefVal == 1 && aliasValue == null) {
                            
                        } else {
                            oneField.defaultValStr = aliasValue;
                            //单文档时 判断当前文件个数
                            if (fieldRole == 18) {
                                if (aliasValue) {
                                    oneField.defaultFileNum = (aliasValue + "").split(",").length;
                                    oneField.fileList = dataInfo[aliasName+"_fileList"];
                                    if(oneField.fileList) {
                                        oneField.fileList.forEach(fileOne => {
                                            fileOne.name = fileOne.name?fileOne.name:fileOne.F_NAME;
                                            fileOne.fileId = fileOne.fileId?fileOne.fileId:fileOne.F_ID;
                                            fileOne.downAddress = fileOne.downAddress?fileOne.downAddress:fileOne.F_MONGOID;
                                        });
                                    }
                                }
                            }
                        }
                        // if (ifShowDefVal == 0 && (ifNullShowDefVal == 0 || aliasValue != null)) {// 
                        // }
                    }
                } else {
                    oneField.defaultValStr = null;
                }
                //富文本类型 进行主键记录
                if(fieldRole == 2) {
                    if(dataInfo[aliasName+"_EDITOR_ID"] > 0) {
                        oneField.EDITOR_ID = dataInfo[aliasName+"_EDITOR_ID"];
                    }
                }
                if (firstNameValue == "") {
                    firstNameValue = aliasValue;
                }
            } else if (fieldRole == 17) {
                //多值选择项
                inputFName = inputFName.substring(0, inputFName.lastIndexOf("_"));
                aliasValue = dataInfo[inputFName + "_dicSql"];
                //数据字典类型
                var dicParId = oneField.dicParId;
                //为空是否显示默认值
                var ifNullShowDefVal = oneField.ifNullShowDefVal;
                //是否强制显示默认值
                var ifShowDefVal = oneField.ifShowDefVal;
                if (ifShowDefVal == 0 && (ifNullShowDefVal == 0 || aliasValue != null)) {
                    oneField.defaultCheckValue = aliasValue;
                    oneField.defaultValStr = oneField.defaultCheckValue;
                }
                utils.dicDefaultCheck(oneField, oneField.defaultCheckValue);
                oneField.defaultValStr = oneField.defaultCheckCnName;
            } else if (fieldRole == 19) {
                //多文档
                //inputFName = inputFName.substring(0, inputFName.lastIndexOf("_"));
                aliasValue = dataInfo[inputFName + "_fileSql"];
                oneField.defaultValStr = aliasValue;
                oneField.defaultFileNum = aliasValue ? (aliasValue + "").split(",").length : 0;
                oneField.fileList = dataInfo[inputFName+"_fileSql_fileList"];
                if(oneField.fileList) {
                    oneField.fileList.forEach(fileOne => {
                        fileOne.name = fileOne.name?fileOne.name:fileOne.F_NAME;
                        fileOne.fileId = fileOne.fileId?fileOne.fileId:fileOne.F_ID;
                        fileOne.downAddress = fileOne.downAddress?fileOne.downAddress:fileOne.F_MONGOID;
                    });
                }
            } else if (relationTableId > 0) {
                //子表格的数据
                var childDataList = dataInfo[relationTableId + "_" + showFieldArr];

                if (zdyAliasName && zdyAliasName != "") {
                    childDataList = dataInfo[zdyAliasName];
                }
                if (childDataList == null || childDataList == undefined || typeof (childDataList) !="object") {
                    if (aliasValue == null || aliasValue == undefined) {
                        oneField.childPageJsonArr = [];
                        oneField.defaultCheckValue = "";
                        oneField.defaultCheckCnName = "";
                        oneField.defaultValStr = "";
                        oneField.defaultCheckUpdateId = "";
                        oneField.defaultCheckValueIndex = '';
                        oneField.defaultCheckIndexArr = [];
                        continue;
                    } else {
                        dataInfo["T_" + childDialogTableId + "_0"] = aliasValue;
                        childDataList = [dataInfo];
                    }
                }
                var childFieldSetBase = oneField.childFieldSet;
                var tmpString1 = JSON.stringify(childFieldSetBase);
                //循环数据进行子表格加载
                oneField.childPageJsonArr = [];
                if (childFieldSetBase.length == 1) {
                    oneField.childHide = true;
                }

                //选中的id
                var checkedId = "";
                var checkedName = "";
                var checkedUpdateId = "";
                var defaultCheckDataList = [];
                var dialogIdName = oneField.dialogIdName;
                var updateIdName = oneField.updateIdName;
                var checkDicList = [];
                for (var j = 0; j < childDataList.length; j++) {
                    var childFieldSet = JSON.parse(tmpString1);
                    defaultCheckDataList[j] = childDataList[j];
                    var childFirstNameValue = "";
                    var childMaxCol = 0;
                    for (var k = 0; k < childFieldSet.length; k++) {
                        childFieldSet[k].prevFieldIndex = (oneField.prevFieldIndex != undefined ? oneField.prevFieldIndex : "") + ":" + (oneField.nowFieldIndex != undefined ? oneField.nowFieldIndex : "") + "-" + prevDateIndex;
                        if(!childFieldSet[k].ifHide) {
                            childMaxCol++;
                        }
                    }
                    if (fieldRole == 20 || fieldRole == 22) {
                        childFirstNameValue = dataInfo[lmfValueFirstAliasName];
                        childFieldSet.forEach((childFieldOne, index) => {
                            childFieldOne.defaultValStr = dataInfo[childFieldOne.fieldAliasName];
                            this.loadFieldRulesByField(childFieldOne);
                        })
                    } else {
                        childFirstNameValue = this.initToUpdateField(childFieldSet, childDataList[j], that, j, childDialogTableId,pageSetInfo);
                    }
                    var oneChildJson = {
                        "fieldSet": childFieldSet,
                        "defaultIdStr": childDataList[j]["T_" + childDialogTableId + "_0"],
                        "nowDataIndex": oneField.childPageJsonArr.length,
                        "prevDateIndex": prevDateIndex,
                        "dialogIdName": dialogIdName,
                        "updateIdName": updateIdName,
                        "updateDataId": childDataList[j]["T_" + relationTableId + "_0"],
                        "dataInfo": childDataList[j],
                        "maxRow":0,
                        "maxCol":childMaxCol>1?childMaxCol-1:childMaxCol,
                        "showHideJsList":pageSetInfo.showHideJsList,
                        "name_indexMap":pageSetInfo.name_indexMap
                    }
                    oneField.childPageJsonArr.push(oneChildJson);
                    oneField.childMaxCol = childMaxCol>1?childMaxCol-1:childMaxCol;
                    if (checkedId != '') {
                        checkedId += ',';
                        checkedName += ',';
                        checkedUpdateId += ",";
                    }
                    checkedId += childDataList[j]["T_" + childDialogTableId + "_0"];
                    checkedName += childFirstNameValue ? childFirstNameValue:'';
                    checkedUpdateId += childDataList[j]["T_" + relationTableId + "_0"];
                    checkDicList.push({
                        DIC_ID: childDataList[j]["T_" + childDialogTableId + "_0"],
                        DIC_NAME: childFirstNameValue ? childFirstNameValue:''
                    });
                }
                oneField.defaultCheckValue = checkedId;
                oneField.defaultCheckCnName = checkedName;
                oneField.defaultValStr = oneField.defaultCheckCnName;
                oneField.defaultCheckUpdateId = checkedUpdateId;
                // if (oneField.dicList && oneField.dicList.length > 0) {
                //     var defaultCheckValueIndex = "";
                //     var defaultCheckIndexArr = [];
                //     oneField.dicList.forEach((dicOne, dicIndex) => {
                //         childDataList.forEach((childDataOne, childDataIndex) => {
                //             if (dicOne.DIC_ID == childDataOne["T_" + childDialogTableId + "_0"]) {
                //                 defaultCheckValueIndex = dicIndex;
                //                 defaultCheckIndexArr.push(dicIndex);
                //             }
                //         });
                //     });
                //     if (oneField.dataMaxNum == 1) {
                //         oneField.defaultCheckValueIndex = defaultCheckValueIndex>=0?defaultCheckValueIndex:"";
                //     } else {
                //         oneField.defaultCheckIndexArr = defaultCheckIndexArr;
                //     }
                // } else {
                    //自动拼接上默认的dicList
                    if(checkDicList.length > 0) {
                        oneField.dicList = checkDicList;
                        oneField.defaultCheckValueIndex = 0;
                        oneField.defaultCheckIndexArr = [];
                        for (let index = 0; index < checkDicList.length; index++) {
                            oneField.defaultCheckIndexArr.push(index);
                        }
                    } else {
                        oneField.defaultCheckValueIndex = '';
                        oneField.defaultCheckIndexArr = [];
                    }
                // }
            //oneField.defaultCheckDataList = defaultCheckDataList;
            } else {
                oneField.defaultCheckValueIndex = null;
                oneField.defaultCheckValue = null;
                oneField.defaultCheckCnName = null;
                oneField.defaultCheckIndexArr = null;
                oneField.defaultCheckDataList = null;
                oneField.defaultValStr = null;
                oneField.defaultCheckUpdateId = null;
                oneField.childPageJsonArr = null;
            }

            //判断是否只新增 ifOnlyAdd
            if(fieldRole == 21 && oneField.ifOnlyAdd == 1) {
                oneField.childPageJsonArr = [];
                oneField.defaultCheckValue = "";
                oneField.defaultCheckCnName = "";
                oneField.defaultValStr = "";
                oneField.defaultCheckUpdateId = "";
                oneField.defaultCheckValueIndex = '';
                oneField.defaultCheckIndexArr = [];
            }
        }
        //}
        
        return firstNameValue;
    },
    /**
     * 加载字段的必填验证信息
     */
    loadFieldRulesByField:function(oneField, that){
        var fieldCnName = oneField.fieldCnName;
        var fieldRole = oneField.fieldRole;
        var pageUtils = this;
        fieldRole = oneField.plugRole > 0 ? oneField.plugRole : fieldRole;
        // 增加必填等验证设置
        var ifMust = oneField.ifMust;
        var ifHide = oneField.ifHide;
        oneField.elRules = [];
        oneField.rules = {};
        oneField.messages = {};
        if ((ifMust == 1 || fieldRole == 3) && (!ifHide)) {
            if (ifMust == 1) {
                oneField.rules.required = true;
                oneField.messages.required = fieldCnName + '必须填写';
                oneField.elRules.push({
                    required: true, message: fieldCnName + '必须填写', trigger: ['change']
                })
            }
        }
        // 内部对象多值
        if (fieldRole == 21 || fieldRole == 20) {
            if(!oneField.childPageJsonArr) {
                oneField.childPageJsonArr = [];
            }
            if(!oneField.defaultCheckValue) {
                oneField.defaultCheckValue = "";
            }
            if(ifMust == 1) {
                oneField.rules.min = 1;
                oneField.messages.min = fieldCnName + '的个数必须大于0个';
            }
        }
        // 身份证类型
        if (fieldRole == 3) {
            oneField.rules.idcard = true;
            oneField.messages.idcard = fieldCnName + ':请输入18位的有效身份证,如果有X请大写!';
            var getCardTypeNumber = function(rule, value, callback){
                const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
                if(reg.test(value) === false && value){
                    callback(new Error('请输入正确格式的身份证号码'))
                }else {
                    callback()
                }
            }
            oneField.elRules.push({
                validator: getCardTypeNumber, message: fieldCnName + ':请输入18位的有效身份证,如果有X请大写!', trigger: ['change']
            })
        }
        //手机号类型
        if(fieldRole == 6) {
            var validatorPhone = function (rule, value, callback) {
                if (!value || value === '') {
                    callback()
                } else if (!/^1\d{10}$/.test(value)) {
                    callback(new Error('手机号格式错误'))
                } else {
                    callback()
                }
            }
            oneField.elRules.push({
                validator: validatorPhone,message: fieldCnName + ':请输入11位手机号!', trigger: ['change']
            })
        }

        //手机号需要进行验证码校验
        if(oneField.styleSet && oneField.styleSet.ifPhoneMsgCheck == 1) {
            if(!oneField.rules) {
                oneField.elRules = [];
                oneField.rules = {};
                oneField.messages = {}
            }
            oneField.rules.tel = true;
            oneField.elRules.push({
                tel: true, message: fieldCnName + ':请输入手机号!', trigger: ['blur', 'change']
            })
            oneField.asyncCheck = true;
        }
        //异步进行失去焦点唯一性校验
        if(oneField.ifToHtValid == 1 && that) {
            // var toHtAwaitValid = async function(nowField,that){
            //     var message = "";
            //     await pageUtils.toHtValid(nowField,that).then(res=>{
            //         if(res.data == "true" || res.data == true) {
            //             // callback()
            //         } else {
            //             message = "存在重复数据,请重新输入";
            //             // callback("存在重复数据,请重新输入");
            //         }
            //     })
            //     return message;
            // }
            async function validatorHtValid(rule, value, callback){
                if (!value || value === '') {
                    callback();
                } else {
                    await pageUtils.toHtValid(oneField,that).then(res=>{
                        if(res.data == "true" || res.data == true) {
                            callback()
                        } else {
                            callback("存在重复数据,请重新输入");
                        }
                    });
                }
            }
            oneField.elRules.push({
                validator: validatorHtValid,message: fieldCnName + ':存在重复数据,请重新输入', trigger: ['change']
            })
        }
    },
    
    /**
     * 后台校验的方法
     */
    toHtValid:function(nowField,that){
        var pageUtils = this;
        return new Promise((resolve,reject)=>{
            var toHtData = pageUtils.getToHtData(that, 0, false);
            toHtData.id = toHtData.mainDataId;
            toHtData.fid = nowField.fieldId;
            toHtData.inputName = nowField.inputFName;
            toHtData.inputNameValue = nowField.defaultValStr;
            var url = 'add_dataValid.do';
            that.$axios.post(url,toHtData).then(res => {
                return resolve(res);
            }).catch(error => {
                return reject(error);
            });
        });
        
    },
    /**
     * 隐藏合并到一个字段中显示的子表格字段
     * @param {} ieldSet 
     * @param {*} that 
     */
    initHideChildField:function(fieldSet,that){
        var fieldTableInfo = that.fieldTableInfo;
        var maxRow = 0;
        var maxCol = 0;  
        for (var i = 0; i < fieldSet.length; i++) {
            var oneField = fieldSet[i];
            if(oneField.row > maxRow) {
                maxRow = oneField.row;
            }
            if(oneField.col > maxCol) {
                maxCol = oneField.col;
            }
            if(oneField.colSpan > 1) {
                that.$set(fieldTableInfo.rowColSpanInfo,'span_'+(oneField.row+1)+'_'+(oneField.col+1)+'_colspan',oneField.colSpan);
                for (let index = 1; index < oneField.colSpan; index++) {
                    that.$set(fieldTableInfo.rowColSpanInfo,'span_'+(oneField.row+1)+'_'+(oneField.col+1+index)+'_colspan',0);
                }
            }
            var rowColFieldList = fieldTableInfo.rowColSpanInfo["fieldList_"+(oneField.row+1)+"_"+(oneField.col+1)];
            if(!rowColFieldList) {
                rowColFieldList = [];
                that.$set(fieldTableInfo.rowColSpanInfo,'fieldList_'+(oneField.row+1)+'_'+(oneField.col+1),rowColFieldList);
            }
            rowColFieldList.push(i);


            //判断子表格的字段是否有在同一位置的,如果有则切换只显示第一个
            var childFieldSet = oneField.childFieldSet;
            if(childFieldSet) {
                var prevCol = -1;
                var prevRow = -1;
                childFieldSet.forEach(element => {
                    if(prevCol == element.col && prevRow == element.row) {
                        element.childHeadHide = 1;
                    }
                    prevCol = element.col;
                    prevRow = element.row;
                    this.clearFieldCheckValue(element,that);
                })
            }
        }
        // console.log("fieldTableInfo=============================",fieldTableInfo);
    },
    /**
     * 添加修改页面加载时 进行默认值的赋值
     */
    initAddOrUpdateDefaultValue:function(fieldSet,that){
        for (var i = 0; i < fieldSet.length; i++) {
            var oneField = fieldSet[i];
            this.initAddOrUpdateDefaultValueOne(oneField,that);
        }
    },
    /**
     * 添加修改页面加载时 进行默认值的赋值
     */
    initAddOrUpdateDefaultValueOne:function(oneField,that) {
        var pageType = that.pageType;
        //为空是否显示默认值
        var ifNullShowDefVal = oneField.ifNullShowDefVal;
        //是否强制显示默认值
        var ifShowDefVal = oneField.ifShowDefVal;
        ifShowDefVal = isNaN(ifShowDefVal) ? 0 : ifShowDefVal;
        ifNullShowDefVal = isNaN(ifNullShowDefVal) ? 0 : ifNullShowDefVal;
        if (pageType == 5) {
            ifShowDefVal = 1;
        }
        var defaultValStr = oneField.true_defaultShowVal;
        var nowValue = oneField.defaultValStr;
        var fieldRole = oneField.fieldRole;
        if(fieldRole == 16) {
            defaultValStr = (oneField.dicDefaultSelect?oneField.dicDefaultSelect:"")+"";
            nowValue = oneField.defaultCheckValue;
        }
        // console.log("defaultValStr================================",oneField.fieldCnName,defaultValStr,ifShowDefVal,ifNullShowDefVal);
        if ((ifShowDefVal == 1 || (ifNullShowDefVal == 1 && (nowValue==null||nowValue==""))) && (defaultValStr && defaultValStr!='null')) {
            var dateType = oneField.dateType;
            // 日期类型字段
            if (dateType && dateType != "") {
                // 判断是否有默认值 进行默认值赋值
                if (defaultValStr && defaultValStr.indexOf("${sysdate") == 0) {
                    var format = defaultValStr.substring(defaultValStr.indexOf("_") + 1, defaultValStr.length - 1)
                    var date = new Date();
                    oneField.defaultValStr = this.dateFormat(date, format);
                    console.info("tmpUserName=====" , format, oneField.defaultValStr);
                }
            }  else if (fieldRole == 16) {
                // 单值选择项类型
                utils.dicDefaultCheck(oneField, oneField.dicDefaultSelect*1);
                oneField.defaultValStr = oneField.defaultCheckCnName;
            } else if(defaultValStr && typeof(defaultValStr) == "string") {
                if (defaultValStr.indexOf("&{SESSION_") == 0) {
                    //从登陆缓存中获取 sessionMap
                    var sessionMap = JSON.parse(localStorage.sessionMap);
                    var sessionId = defaultValStr.substring(12, defaultValStr.lastIndexOf("_"));
                    var checkedId = sessionMap['SESSION_' + sessionId];
                    var checkedName = sessionMap['SESSION_NAME_' + sessionId];
                    if (oneField.dataMaxNum == 1) {
                        checkedId = checkedId.split(",")[0];
                        checkedName = checkedName.split(",")[0];
                    }
                    oneField.defaultCheckValue = checkedId;
                    oneField.defaultCheckCnName = checkedName;
                } else if (defaultValStr.indexOf("${USER_") == 0) {
                    var loginInfo = JSON.parse(localStorage.loginInfo);
                    var tmpUserName = defaultValStr.substring(2, defaultValStr.length - 1);
                    oneField.defaultCheckValue = loginInfo[tmpUserName];
                    oneField.defaultCheckCnName = loginInfo[tmpUserName];
                } else if (defaultValStr.indexOf("${USERID}") == 0 || defaultValStr.indexOf("${USERID_") == 0) {
                    var loginInfo = JSON.parse(localStorage.loginInfo);
                    var checkedId = loginInfo.USERID;
                    var checkedName = loginInfo.USERNAME;
                    oneField.defaultCheckValue = checkedId;
                    oneField.defaultCheckCnName = checkedName;
                } else  {
                    oneField.defaultValStr = defaultValStr;
                }
            }
        }
        if (oneField.childFieldSet && oneField.childFieldSet.length > 0) {
            this.initAddOrUpdateDefaultValue(oneField.childFieldSet,that);
        }
    },
    /**
     * 初始化 列表或 修改查看页面的按钮设置
     */
    initOperaButtonSet:function(pageSetInfo, pageId, that) {
        var operaButtonSet = pageSetInfo.operaButtonSet;
        console.log("localStorage.user_buttons===============",that.isLimitButton);
        //获取登录人的权限信息
        var user_buttons = localStorage.user_buttons?localStorage.user_buttons:'';
        var loginInfo = JSON.parse(localStorage.loginInfo?localStorage.loginInfo:null);
        var USERID = 0;
        if(that.isLimitButton) {
            USERID = loginInfo?loginInfo.USERID:-1
        }
        var buttonCssStyle = 0;
        var actionSheetArr = [];
        if (operaButtonSet && operaButtonSet != undefined) {
            var ifShowTrueNum = 0;
            for (var i = 0; i < operaButtonSet.length; i++) {
                var buttonId = operaButtonSet[i].buttonId;
                if (user_buttons.indexOf("," + pageId + "_" + buttonId + ",") >= 0 || USERID == 0 || (operaButtonSet[i].styleSet && operaButtonSet[i].styleSet.ifRoleLimit == 1)) {
                operaButtonSet[i].ifShow = true;
                ifShowTrueNum++;
                } else {
                operaButtonSet[i].ifShow = false;
                }
                if (operaButtonSet[i].styleSet) {
                    if (operaButtonSet[i].styleSet.cssStyle == 6) {
                        buttonCssStyle = 6;
                    } else if (operaButtonSet[i].styleSet.cssStyle == 9) {
                        actionSheetArr.push({
                          name: operaButtonSet[i].buttonName,
                          index : i
                        })
                    }
                } else {
                    operaButtonSet[i].styleSet = {};
                }
            }
            if (ifShowTrueNum == 0) {
                pageSetInfo.operaButtonSetIfHide = false;
            } else {
                pageSetInfo.operaButtonSetIfHide = true;
            }
        }
        if(that) {
            that.actionSheetArr = actionSheetArr;
        }
        return buttonCssStyle;
    },
    /**
     * 初始化 修改查看页面的保存按钮设置
     */
    initUpdateButtonSet:function(pageSetInfo, pageId, that){
        var updateButtonSet = pageSetInfo.styleSet.updateButtonSet;
        if (updateButtonSet && updateButtonSet != undefined) {
            for (var i = 0; i < updateButtonSet.length; i++) {
                updateButtonSet[i].ifShow = true;
                if(!updateButtonSet[i].styleSet) {
                    updateButtonSet[i].styleSet = updateButtonSet[i];
                }
            }
            if(pageSetInfo.pageType == 11) {
                updateButtonSet[0].ifShow = false;
            }
            var loginInfo = JSON.parse(localStorage.loginInfo?localStorage.loginInfo:null);
            var USERID = 0;
            if(loginInfo) {
                USERID = loginInfo?loginInfo.USERID:-1
            }
            if(USERID == 0) {
                //判断如果登陆人为 admin超级管理员  增加接口文档查看的按钮
                // updateButtonSet[updateButtonSet.length] = {
                //     buttonName:"接口查看",
                //     buttonType:99,
                //     cssStyle:1,
                //     ifShow:true,
                //     styleSet:{
                //         cssStyle:1
                //     }
                // }
            }
        }


    },
    /**
     * 初始化 列表的 总的按钮样式设置
     */
    initTotalButtonSet: function (pageSetInfo, pageId, that) {
        var buttonSet = pageSetInfo.buttonSet;
        //获取登录人的权限信息
        var user_buttons = localStorage.user_buttons?localStorage.user_buttons:'';
        var loginInfo = JSON.parse(localStorage.loginInfo?localStorage.loginInfo:null);
        var USERID = 0;
        if(that.isLimitButton) {
            USERID = loginInfo?loginInfo.USERID:-1
        }
        if (buttonSet && buttonSet != undefined) {
            var ifShowTrueNum = 0;
            for (var i = 0; i < buttonSet.length; i++) {
                var buttonId = buttonSet[i].buttonId;
                if (user_buttons.indexOf("," + pageId + "_" + buttonId + ",") >= 0 || (buttonSet[i].styleSet && buttonSet[i].styleSet.ifRoleLimit == 1)) {
                buttonSet[i].ifShow = true;
                ifShowTrueNum++;
                } else {
                buttonSet[i].ifShow = false;
                }
                if (pageSetInfo.buttonFlag == 1 || USERID == 0) {
                buttonSet[i].ifShow = true;
                ifShowTrueNum++;
                }
                // console.info("ifShow=11111========" + buttonSet[i].ifShow);
            }
            if (ifShowTrueNum == 0) {
                pageSetInfo.buttonSetIfHide = false;
            } else {
                pageSetInfo.buttonSetIfHide = true;
            }
        }
    },
    /**
     * 页面信息加载后 进行搜索条件的初始化加载
     */
    loadInitSearchSet: function (that){
        var pageUtils = this;
        var pageSetInfo = that.pageSetInfo;
        var searchSet = pageSetInfo.fieldSet;
        var inFieldArr = [];
        var outFieldArr = [];
        // 初始选中的值
        var initSearchValJson = {};
        // 初始的搜索条件
        if (that.initSearchVal != "") {
            initSearchValJson = JSON.parse(that.initSearchVal);
        }
        if (searchSet) {
            for (var i = 0; i < searchSet.length; i++) {
                //获取别名 判断是否需要默认进行选中值
                var searchSetOne = searchSet[i];
                
                if(!searchSetOne.styleSet) {
                    searchSetOne.styleSet = {};
                }
                var fieldAliasName = searchSetOne.fieldAliasName;
                var initVal = initSearchValJson[fieldAliasName];
                if (initVal && initVal.length > 0) {
                    searchSetOne.defaultValStr = initVal;
                }
                // 如果字段是日期类型 进行默认选中值的赋值
                if (searchSetOne.fieldType == 3) {
                    this.initLoadDateSearchDefault(searchSetOne,that);
                    if (searchSetOne.dateType == "yyyy-MM") {
                        searchSetOne.dateTypeFields = "month";
                    } else if (searchSetOne.dateType == "yyyy"){
                        searchSetOne.dateTypeFields = "year";
                    } else {
                        searchSetOne.dateTypeFields = "day";
                    }
                }
                // 如果是数据字典类型初始化默认赋值
                if (searchSetOne.fieldType == 4 || searchSetOne.tcPageId > 0 || searchSetOne.styleSet.showStyle == 7) {
                    that.$set(searchSetOne,"defaultCheckIndexArr",[]);
                    that.$set(searchSetOne,"defaultCheckValue","");
                    //判断是否有默认选中值 如果有则进行默认选中
                    if(searchSetOne.dicDefaultSelect && searchSetOne.dicDefaultSelect != "") {
                        utils.dicDefaultCheck(searchSetOne, searchSetOne.dicDefaultSelect);
                    }
                }
        
                if (searchSetOne.styleSet) {
                    // 判断是否是 日历搜索形式 如果是则传递搜索条件为 本月
                    if (searchSetOne.styleSet.showStyle == 3 || searchSetOne.styleSet.showStyle == 4) {
                        var nowDate = new Date();
                        var showDataFilter = {'DAY':nowDate.getDate()}
                        // that.setData({
                        //     showDataFilter: {
                        //         "DAY": nowDate.getDate()
                        //     }
                        // });
                    }
                    // 标签搜索增加全部的搜索项  || searchSetOne.styleSet.showStyle == 7
                    if ((searchSetOne.styleSet.showStyle == 2) && searchSetOne.styleSet.ifClose == 2) {
                        //获取数据后转为 dicList
                        if(searchSetOne.pageDialog > 0) {
                            this.autoGetDialogDataByInfo(that,searchSetOne,searchSetOne.tcTableId,searchSetOne.pageDialog,1,0,"3");
                        } else {
                            this.searchSetOneLoadDicList(searchSetOne,null);
                        }
                    } else if(searchSetOne.styleSet.showStyle == 10) {
                        searchSetOne.showStyle10Value = "1";
                    }
                    if(searchSetOne.styleSet.defaultCheck>0) {
                        //选中第一项
                        if(searchSetOne.styleSet.defaultCheck == 1 || searchSetOne.styleSet.defaultCheck == 3) {
                            var initCheckIndex = searchSetOne.styleSet.defaultCheck == 3?(searchSetOne.dicList.length - 1):0;
                            searchSetOne.defaultCheckValueIndex = initCheckIndex;
                            searchSetOne.defaultCheckIndexArr = [initCheckIndex];
                            searchSetOne.defaultCheckValue = searchSetOne.dicList[initCheckIndex].DIC_ID;
                            searchSetOne.defaultCheckCnName = searchSetOne.dicList[initCheckIndex].DIC_NAME;
                            searchSetOne.defaultValStr = searchSetOne.defaultCheckCnName;
                        } else if(searchSetOne.styleSet.defaultCheck == 2) {
                            var initCheckIndexArr = [];
                            searchSetOne.dicList.forEach((dicOne,dicIndex) => {
                                initCheckIndexArr.push(dicIndex);
                            })
                            //全部选中
                            searchSetOne.defaultCheckIndexArr = initCheckIndexArr;
                            pageUtils.bindPickerChange(that, searchSetOne);
                        }
                        console.log("searchSetOne===========================",searchSetOne);
                    }


                    if (searchSetOne.styleSet.ifClose == 1) {
                        inFieldArr.push(searchSetOne);
                    } else {
                        outFieldArr.push(searchSetOne);
                    }
                } else {
                    outFieldArr.push(searchSetOne);
                }
                
            }
            pageSetInfo.outFieldArr = outFieldArr;
            pageSetInfo.inFieldArr = inFieldArr;
            var toHtData1 = pageUtils.initSearchListData(outFieldArr);
            var toHtData2 = pageUtils.initSearchListData(inFieldArr);
            var kwSearchToHtData = Object.assign(toHtData1, toHtData2);
            console.log("kwSearchToHtData================================",kwSearchToHtData);
            that.kwSearchToHtData = kwSearchToHtData;
            that.pageSetInfo = pageSetInfo;
        }
    },
    /**
     * 搜索条件为标签搜索加载dicList后的处理逻辑
     */
    searchSetOneLoadDicList:function(searchSetOne,pageDataInfo){
        var tableId = searchSetOne.tcTableId;
        if(pageDataInfo) {
            var autoDicList = [];
            pageDataInfo.forEach((dataOne, dataIndex) => {
                var dicOne = {
                    DIC_ID: dataOne["T_"+tableId+"_0"],
                    DIC_NAME: dataOne.AFM_1
                }
                dicOne = Object.assign(dicOne, dataOne);
                autoDicList.push(dicOne);
            });
            searchSetOne.dicList = autoDicList;
        }
        if (!searchSetOne.defaultCheckValueIndex && searchSetOne.dicList) {
            // 标签搜索增加全部的搜索项
            if (searchSetOne.styleSet.searchNameCustomHide == 1) {
                if (searchSetOne.dicList) {
                    var name;
                    if (searchSetOne.styleSet.searchNameCustom) {
                        name = searchSetOne.styleSet.searchNameCustom
                    } else {
                        name = "全部"
                    }
                    searchSetOne.dicList.unshift({ "DIC_ID": "0", "DIC_NAME": name });
                }
            }
            var initCheckIndex = 0;
            // 如果设置了过滤条件
            if (searchSetOne.styleSet.filterParent && searchSetOne.styleSet.filterParent >= 0) {
                searchSetOne.dicList.forEach((dicOne,dicIndex) => {
                if (initCheckIndex == 0) {
                    if (searchSet[searchSetOne.styleSet.filterParent].defaultCheckValue == dicOne.FILTER_ID || dicOne.DIC_ID == 0) {
                    initCheckIndex = dicIndex;
                    }
                }
                })
            } 
            if (searchSetOne.dicList.length > initCheckIndex) {
                searchSetOne.defaultCheckValueIndex = initCheckIndex;
                searchSetOne.defaultCheckValue = searchSetOne.dicList[initCheckIndex].DIC_ID;
                searchSetOne.defaultCheckCnName = searchSetOne.dicList[initCheckIndex].DIC_NAME;
                searchSetOne.defaultValStr = searchSetOne.defaultCheckCnName;
            }
        }
    },
    /**
     * 搜索条件的日期字段 根据设置的默认值 进行初始赋值
     */
    initLoadDateSearchDefault: function (element,that){
        var startDate = "";
        var endDate = "";
        //判断是否有默认选中值  defDateRange
        if (element.defDateRange == 1) {//本月
            var startDefDate = new Date();
            startDefDate.setDate(1);
            var endDefDate = new Date();
            endDefDate.setMonth(endDefDate.getMonth() + 1);
            endDefDate.setDate(0);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 2) {//本周
            var weekDay = new Date().getDay();
            var monthDate = new Date().getDate();
            var startDefDate = new Date();
            startDefDate.setDate(monthDate - (weekDay == 0 ? 7 : weekDay) + 1);
            var endDefDate = new Date();
            endDefDate.setDate(monthDate - (weekDay == 0 ? 7 : weekDay) + 7);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 3) {//与当前相差天数 betweenDay
            var startDefDate = new Date();
            var endDefDate = new Date();
            endDefDate.setDate(endDefDate.getDate() + element.betweenDay);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 4) {//本年
            var startDefDate = new Date();
            startDefDate.setMonth(0);
            startDefDate.setDate(1);
            var endDefDate = new Date();
            endDefDate.setFullYear(endDefDate.getFullYear() + 1);
            endDefDate.setMonth(0);
            endDefDate.setDate(0);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 5) {//昨天
            var startDefDate = new Date();
            startDefDate.setDate(startDefDate.getDate() - 1);
            var endDefDate = new Date();
            endDefDate.setDate(endDefDate.getDate() - 1);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 6) {//上周
            var weekDay = new Date().getDay();
            var monthDate = new Date().getDate();
            var startDefDate = new Date();
            startDefDate.setDate(monthDate - weekDay - 6);
            var endDefDate = new Date();
            endDefDate.setDate(monthDate - weekDay);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 7) {//上月
            var startDefDate = new Date();
            startDefDate.setMonth(startDefDate.getMonth() - 1);
            startDefDate.setDate(1);
            var endDefDate = new Date();
            endDefDate.setDate(0);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 8) {//去年
            var startDefDate = new Date();
            startDefDate.setFullYear(startDefDate.getFullYear() - 1);
            startDefDate.setMonth(0);
            startDefDate.setDate(1);
            var endDefDate = new Date();
            endDefDate.setMonth(0);
            endDefDate.setDate(0);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 9) {//上季度
            var yearMonth = new Date().getMonth();
            var startMonth = (yearMonth / 3).toFixed(0) * 3 - 3;
            var endMonth = (yearMonth / 3).toFixed(0) * 3;
            var startDefDate = new Date();
            startDefDate.setMonth(startMonth);
            startDefDate.setDate(1);
            var endDefDate = new Date();
            endDefDate.setMonth(endMonth);
            endDefDate.setDate(0);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else if (element.defDateRange == 10) {//本季度
            var yearMonth = new Date().getMonth();
            var startMonth = 0 + (yearMonth / 3).toFixed(0) * 3;
            var endMonth = 3 + (yearMonth / 3).toFixed(0) * 3;
            var startDefDate = new Date();
            startDefDate.setMonth(startMonth);
            startDefDate.setDate(1);
            var endDefDate = new Date();
            endDefDate.setMonth(endMonth);
            endDefDate.setDate(0);
            startDate = this.dateFormat(startDefDate, element.dateType);
            endDate = this.dateFormat(endDefDate, element.dateType);
        } else {
            startDate = "";
            endDate = "";
        }
        that.$set(element,"startDateObject",startDate);
        that.$set(element,"endDateObject",endDate);
        that.$set(element,"startDate",startDate);
        that.$set(element,"endDate",endDate);
    },
    /**
     * 根据传递的 字段数组 进行后台数据查询搜索条件的数据结构构造
     */
    initSearchListData : function (fieldSet){
        //获取其他的搜索条件的信息
        var toHtData = {};
        if (fieldSet) {
        for (var i = 0; i < fieldSet.length; i++) {
            //搜索条件类型
            var fieldType = fieldSet[i].fieldType;
            //搜索条件别名
            var fieldAliasName = fieldSet[i].fieldAliasName;
            //搜索条件的结果值
            var defaultCheckValue = fieldSet[i].defaultCheckValue;
            var defaultValStr = fieldSet[i].defaultValStr;
            //如果是弹出层 页面的ID
            var tcPageId = fieldSet[i].tcPageId;
            //当类型为1时，数字搜索条件或弹出层搜索条件
            if (fieldType == 1 && tcPageId == 0) {
            // if (tcPageId > 0) {
            //   if (defaultCheckValue && defaultCheckValue.length > 0) {
            //     toHtData[fieldAliasName + '_4_andOr'] = 0;
            //     toHtData[fieldAliasName + '_4_dicCond_pld'] = 0;
            //     toHtData[fieldAliasName + '_searchEleId'] = defaultCheckValue ? defaultCheckValue : '';
            //   } 
            //   // else if (defaultValStr && defaultValStr.length > 0) {
            //   //   toHtData[fieldAliasName + '_4_andOr'] = 0;
            //   //   toHtData[fieldAliasName + '_4_dicCond_pld'] = 0;
            //   //   toHtData[fieldAliasName + '_searchEleId'] = defaultValStr ? defaultValStr : '';
            //   // }
                
            // } else {
                var startValue = fieldSet[i].startValue;
                var endValue = fieldSet[i].endValue;
                toHtData[fieldAliasName + '_1_andOr'] = 0;
                toHtData[fieldAliasName + '_numCondOne_pld'] = 1;
                toHtData[fieldAliasName + '_numValOne_pld'] = startValue ? startValue : '';
                toHtData[fieldAliasName + '_numCondTwo_pld'] = 1;
                toHtData[fieldAliasName + '_numValTwo_pld'] = endValue ? endValue : '';
            // }
            //当类型为2时，字符搜索条件
            } else if (fieldType == 2) {
            if (tcPageId > 0) {
                if ((defaultCheckValue != null && defaultCheckValue != undefined) && (defaultCheckValue > 0 || defaultCheckValue.length > 0) && defaultCheckValue != 0) {
                toHtData[fieldAliasName + '_5_dicCond_pld'] = 0;
                toHtData[fieldAliasName + '_5_andOr'] = 0;
                toHtData[fieldAliasName + '_searchEleId'] = defaultCheckValue ? defaultCheckValue : '';
                toHtData[fieldAliasName + '_searchEle'] = defaultCheckValue ? defaultCheckValue : '';
                }
            } else {
                toHtData[fieldAliasName + '_2_andOr'] = 0;
                toHtData[fieldAliasName + '_strCond_pld'] = 0;
                toHtData[fieldAliasName + '_strVal_pld'] = defaultValStr ? defaultValStr : '';
            }
            //当类型为3时，日期搜索条件
            } else if (fieldType == 3) {
            var dateType = fieldSet[i].dateType;
            var startDate = fieldSet[i].startDate;
            var endDate = fieldSet[i].endDate;
            toHtData[fieldAliasName + '_3_andOr'] = 0;
            toHtData[fieldAliasName + '_dateType'] = dateType;
            toHtData[fieldAliasName + '_startDates_pld'] = startDate ? startDate : null;
            toHtData[fieldAliasName + '_endDates_pld'] = endDate ? endDate : null;
            //当类型为4时，下拉框搜索条件
            } else if (fieldType == 4 || tcPageId > 0) {
                if ((defaultCheckValue != null && defaultCheckValue != undefined) && (defaultCheckValue > 0 || defaultCheckValue.length > 0) && defaultCheckValue != 0) {
                    // if (tcPageId > 0) {
                    //   toHtData[fieldAliasName + '_5_dicCond_pld'] = 0;
                    //   toHtData[fieldAliasName + '_5_andOr'] = 0;
                    //   toHtData[fieldAliasName + '_searchEleId'] = defaultCheckValue ? defaultCheckValue : '';
                    //   toHtData[fieldAliasName + '_searchEle'] = defaultCheckValue ? defaultCheckValue : '';
                    // } else {
                    toHtData[fieldAliasName + '_d_andOr'] = 0;
                    toHtData[fieldAliasName + '_d_dicCond_pld'] = 0;
                    toHtData[fieldAliasName + 'strCond_dic'] = defaultCheckValue ? defaultCheckValue : '';
                    // }
                }
            }
            //fieldSet[i].defaultCheckCnName = "";
            //fieldSet[i].searchDeafultVal = "";
            //fieldSet[i].startDate = "";
            //fieldSet[i].endDate = "";
            //fieldSet[i].defaultCheckValue = "";
        }
        }
        return toHtData;
    },
    /**
     * input框切换事件
     */
    bindInputBlur: function (that, fieldOne) {
        var fieldId = fieldOne.fieldId;
        // 调用自定义回调事件 
        if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
            that["zdyValueChange_"+fieldId](that,utils,pageUtils);
        }
    },
    /**
     * 日期字段切换事件
     * @param {} that 
     * @param {} fieldOne 
     */
    bindDateChange: function (that, fieldOne) {
        var fieldId = fieldOne.fieldId;
        // 调用自定义回调事件 
        if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
            that["zdyValueChange_"+fieldId](that,utils,pageUtils);
        }
    },

    /**
     * 弹出层字段当表现为下拉框时切换事件
     */
    bindDialogChange: function (fieldSetIndexArr,that) {
        var nowValue = fieldSetIndexArr.defaultCheckIndexArr;
        if(fieldSetIndexArr.dataMaxNum==1) {
            nowValue = fieldSetIndexArr.defaultCheckValueIndex
        }
        var nowValueArr = [];
        var dicList = fieldSetIndexArr.dicList;
        if (typeof (nowValue) == "object") {
            nowValueArr = nowValue;
        } else {
            if(typeof (nowValue) == "number") {
                nowValueArr.push(nowValue);
            }
        }
        var nowDxCheckDefaultCheckCnName = '';
        var nowDxCheckDefaultCheckId = '';
        var checkDataInfo = [];
        for (var j = 0; j < dicList.length; j++) {
            dicList[j].CHECKED = false;
        }
        var dialogTableId = fieldSetIndexArr.dialogTableId;
        for (var j = 0; j < nowValueArr.length; j++) {
            var checkOne = dicList[nowValueArr[j]];
            checkOne.CHECKED = true;
            if (nowDxCheckDefaultCheckCnName != '') {
                nowDxCheckDefaultCheckCnName += ',';
                nowDxCheckDefaultCheckId += ',';
            } 
            nowDxCheckDefaultCheckCnName += (checkOne.NAME ? checkOne.NAME : checkOne.AFM_1);
            nowDxCheckDefaultCheckId += checkOne["T_" + dialogTableId + "_0"] ? checkOne["T_" + dialogTableId + "_0"]:checkOne.LMF_ID;
            checkDataInfo.push(checkOne);
        }
        
        fieldSetIndexArr.defaultCheckValue = nowDxCheckDefaultCheckId;
        fieldSetIndexArr.defaultCheckCnName = nowDxCheckDefaultCheckCnName;
        fieldSetIndexArr.defaultCheckDataList = checkDataInfo;
        fieldSetIndexArr.defaultCheckValueIndex = nowValue;
        fieldSetIndexArr.defaultCheckIndexArr = nowValueArr;
        var fieldId = fieldSetIndexArr.fieldId;
        // 调用自定义回调事件 
        if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
            that["zdyValueChange_"+fieldId](that,utils,pageUtils);
        }
    },
    // 清除字段的值
    clearFieldCheckValue:function(fieldOne,that){
        that.$set(fieldOne,"defaultCheckValueIndex",null);
        that.$set(fieldOne,"defaultCheckValue",null);
        that.$set(fieldOne,"defaultCheckCnName","");
        that.$set(fieldOne,"defaultCheckIndexArr",[]);
        that.$set(fieldOne,"defaultCheckDataList",[]);
        that.$set(fieldOne,"defaultValStr","");
        that.$set(fieldOne,"defaultCheckUpdateId","");
        that.$set(fieldOne,"childPageJsonArr",[]);
        // if(that) {
        //     that.$forceUpdate();
        // }
    },

    bindDialogChangeByDataArr:function(fieldSetIndexArr,checkDataInfo,clickValue){
        var cnName = "";
        var defaultCheckUpdateId = "";
        var newCheckValue = "";
        checkDataInfo.forEach(item=>{
            var tmpCnName = (item.NAME ? item.NAME:(item.name?item.name:item.AFM_1));
            if(!tmpCnName) {
                tmpCnName = item[fieldSetIndexArr.childFieldSet[0].fieldName];
            }
            cnName += (cnName != "" ? "," : "") + tmpCnName;
            newCheckValue += (newCheckValue != "" ? "," : "") + (item.LMF_ID ? item.LMF_ID:(item.id?item.id:item["T_" + fieldSetIndexArr.dialogTableId + "_0"]));
            defaultCheckUpdateId += (cnName != "" ? "," : "") + "";
        })
        if(clickValue) {
            fieldSetIndexArr.defaultCheckValue = clickValue;
            fieldSetIndexArr.defaultValStr = fieldSetIndexArr.defaultCheckValue;
        } else {
            fieldSetIndexArr.defaultCheckValue = newCheckValue;
            fieldSetIndexArr.defaultValStr = fieldSetIndexArr.defaultCheckValue;
        }
        fieldSetIndexArr.defaultCheckCnName = cnName;
        fieldSetIndexArr.defaultCheckUpdateId = defaultCheckUpdateId;
        fieldSetIndexArr.defaultCheckDataList = checkDataInfo;
    },

    /**
     * 下拉框picker组件切换时进行赋值 传递的结果为选中的第几个字典值
     */
    bindPickerChange: function (that, fieldOne) {
        var nowValue = fieldOne.defaultCheckIndexArr;
        var dicList = fieldOne.dicList;
        var nowValueArr = [];
        if (typeof (nowValue) == "object") {
            nowValueArr = nowValue;
        } else {
            nowValueArr.push(nowValue);
        }
        var nowDxCheckDefaultCheckCnName = '';
        var nowDxCheckDefaultCheckId = '';
        for (var j = 0; j < dicList.length; j++) {
            dicList[j].CHECKED = false;
        }
    
        for (var j = 0; j < nowValueArr.length; j++) {
            dicList[nowValueArr[j]].CHECKED = true;
            if (nowDxCheckDefaultCheckCnName != '') {
                nowDxCheckDefaultCheckCnName += ',';
                nowDxCheckDefaultCheckId += ',';
            }
            nowDxCheckDefaultCheckCnName += dicList[nowValueArr[j]].DIC_NAME;
            nowDxCheckDefaultCheckId += dicList[nowValueArr[j]].DIC_ID;
        }
        fieldOne.defaultCheckCnName = nowDxCheckDefaultCheckCnName;
        fieldOne.defaultCheckValue = nowDxCheckDefaultCheckId;
        fieldOne.defaultValStr = fieldOne.defaultCheckCnName;
        fieldOne.defaultCheckValueIndex = nowValue;
        fieldOne.defaultCheckIndexArr = nowValueArr;

        var fieldId = fieldOne.fieldId;
        // 调用自定义回调事件 
        if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
            that["zdyValueChange_"+fieldId](that,utils,pageUtils);
        }
    },
    /**
     * 下拉框picker组件切换时进行赋值  选中值为 下拉框的defaultValue
     */
    bindPickerChangeValue: function (that, fieldOne) {
        var nowValue = fieldOne.defaultCheckValue;
        var dicList = fieldOne.dicList;
        var nowValueArr = [];
        if (typeof (nowValue) == "object") {
            nowValueArr = nowValue;
        } else {
            nowValueArr.push(nowValue);
        }
        var nowDxCheckDefaultCheckCnName = '';
        var nowDxCheckDefaultCheckId = '';
        for (var i = 0; i < dicList.length; i++) {
            dicList[i].CHECKED = false;
            var tmpIfCheck = false;
            for (var j = 0; j < nowValueArr.length; j++) {
                if (dicList[i].DIC_ID == nowValueArr[j]) {
                    tmpIfCheck = true;
                }
            }
            if (tmpIfCheck) {
                dicList[i].CHECKED = true;
                if (nowDxCheckDefaultCheckCnName != '') {
                    nowDxCheckDefaultCheckCnName += ',';
                    nowDxCheckDefaultCheckId += ',';
                }
                nowDxCheckDefaultCheckCnName += dicList[i].DIC_NAME;
                nowDxCheckDefaultCheckId += dicList[i].DIC_ID;
            } else {
                dicList[i].CHECKED = false;
            }
        }
        fieldOne.defaultCheckCnName = nowDxCheckDefaultCheckCnName;
        // fieldOne.defaultCheckValue = nowDxCheckDefaultCheckId;
        // that.$set(fieldOne,"defaultCheckValue","");
        // that.$set(fieldOne,"defaultCheckValue",nowDxCheckDefaultCheckId);
        fieldOne.defaultValStr = fieldOne.defaultCheckCnName;
        var fieldId = fieldOne.fieldId;
        console.log("fieldId==========================",fieldId,typeof(that["zdyValueChange_"+fieldId]),fieldOne);
        // 调用自定义回调事件 
        if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
            that["zdyValueChange_"+fieldId](that,utils,pageUtils);
        }
        that.$forceUpdate();
        // fieldOne.defaultCheckValueIndex = nowValue;
        // fieldOne.defaultCheckIndexArr = nowValueArr;
    },

    /**
     * 列表按钮点击事件
     */
    dataButtonClick:function(that,buttonOne,dataInfo){
        //列表的tableId
        var listTableId = that.pageSetInfo.tableId;
        //按钮类型
        var buttonType = buttonOne.buttonType;
        //按钮跳转页面id
        var startTurnPage = buttonOne.startTurnPage;
        //按钮跳转的对象id
        var turnTableId = buttonOne.tableId;
        //提示信息
        var operaPrompt = buttonOne.operaPrompt;

        //打开方式 openWay
        var openWay = buttonOne.styleSet?buttonOne.styleSet.openWay:1;
        //当前的数据的id
        var nowDataId = 0;
        if(dataInfo) {
            nowDataId = dataInfo.LMF_ID;
            if (nowDataId == undefined) {
                nowDataId = dataInfo["T_" + listTableId + "_0"];
                dataInfo.LMF_ID = nowDataId;
            }
        }
        if (buttonOne.ralationTableId > 0) {
            listTableId = buttonOne.ralationTableId;
        }
        //打开方式为加载详情页
        if(openWay == 6) {
            var detailPageInfo = {};
            detailPageInfo.ifLoaded = false;
            that.detailPageInfo = detailPageInfo;
            that.$nextTick(function(){
                detailPageInfo = {
                    pageId: startTurnPage,
                    tableId: turnTableId,
                    mainId: nowDataId,
                    pageType: 11,
                    listTableId: listTableId,
                    ifLoaded: true
                };
                that.detailPageInfo = detailPageInfo;
            });
        } else {
            if (buttonType == 18) {
                nowDataId = dataInfo[buttonOne.relationField];
                //关联添加功能
                var jumpJson = {
                    pageId: startTurnPage,
                    tableId: turnTableId,
                    mainId: nowDataId,
                    callBackType: 1,
                    listTableId: listTableId,
                    pageType:5,
                    openWay:openWay,
                    menuName:buttonOne.buttonName,
                    zdyOtherParam:dataInfo.zdyOtherParam
                };
                console.log("---jumpJson--++",jumpJson);
                this.toNewLookPage(that,jumpJson);
            } else if (buttonType == 12) {
                nowDataId = dataInfo[buttonOne.relationField];
                //修改功能
                var jumpJson = {
                    pageId: startTurnPage,
                    tableId: turnTableId,
                    mainId: nowDataId,
                    callBackType: 1,
                    pageType:7,
                    listTableId: listTableId,
                    openWay:openWay,
                    menuName:buttonOne.buttonName,
                    zdyOtherParam:dataInfo.zdyOtherParam
                };
                this.toNewLookPage(that,jumpJson);
            } else if (buttonType == 15) {
                var menuName = buttonOne.buttonName;
                if(dataInfo.NAME) {
                    menuName = buttonOne.buttonName + "_" + dataInfo.NAME.substring(0,4)+(dataInfo.NAME.length>4?'...':'');
                }
                // 去查看页面
                nowDataId = dataInfo[buttonOne.relationField];
                    var jumpJson = {
                    pageId: startTurnPage,
                    tableId: turnTableId,
                    mainId: nowDataId,
                    callBackType: 1,
                    pageType:11,
                    listTableId: listTableId,
                    openWay:openWay,
                    menuName:menuName
                };
                this.toNewLookPage(that,jumpJson);
            } else if (buttonType == 13) {
                //删除
                this.deleteDataById(nowDataId, that, buttonType, operaPrompt);
            } else if (buttonType == 21) {
                //直接操作按钮
                var directSetIds = buttonOne.directSetIds;
                if(nowDataId > 0) {
                    this.dicrectTrigger(nowDataId, that, buttonType, directSetIds, operaPrompt, listTableId, buttonOne, dataInfo);
                } else {
                    //获取要删除的选中数据 如果没有提示请选中数据 如果有则提示是否删除 如果选择是则调用删除功能
                    var checkedId = '';
                    if(that.$refs.kw_list_default) {
                        var kw_list_default = typeof(that.$refs.kw_list_default.length)=='number'?that.$refs.kw_list_default[0]:that.$refs.kw_list_default;
                        if(kw_list_default && kw_list_default.selectionNodes.length > 0) {
                            var tableId = that.tableId;
                            kw_list_default.selectionNodes.forEach(dataInfo => {
                                checkedId += (checkedId==""?"":",") + dataInfo["T_" + tableId + "_0"]
                            });
                        }
                    } else {
                        if(that.pageDataInfo) {
                            that.pageDataInfo.forEach(dataInfo => {
                                if(dataInfo.RADIO_CHECK_STATE) {
                                    checkedId += (checkedId==""?"":",") + dataInfo["T_" + that.tableId + "_0"]
                                }
                            });
                        }
                    }
                    if (checkedId == "") {
                        that.$message({
                            showClose: true,
                            message: '请选中数据进行批量操作！',
                            type: 'error'
                        });
                    } else {
                        this.dicrectTrigger(checkedId, that, buttonType, directSetIds, operaPrompt, listTableId, buttonOne, dataInfo);
                    }
                }
            } else if (buttonType == 19 || buttonType == 9) {
                //跳转url功能
                var url = buttonOne.startTurnPageUrl;
                console.log("url=======================",url);
                var paramValue = buttonOne.paramValue;
                // 如果URL地址 是跳转展示互动
                if (url.indexOf("Gensee") >= 0) {
                    this.goToGensee(dataInfo,that);
                } else if (url.indexOf("GENSEE_COURSEWARE") >= 0) {
                    // 展示互动回看功能
                    this.goToGenseeCourseWare(dataInfo,that);
                } else if (url.indexOf("bjyLive") >= 0) {
                    var tablePage = url.substring(8);
                    var turnTableId = 0;
                    var startTurnPage = 0;
                    if (tablePage && tablePage.indexOf(":") > 0) {
                        turnTableId = tablePage.split(":")[0];
                        startTurnPage = tablePage.split(":")[1];
                    }
                    // 打开百家云的直播功能
                    this.goToBjyLive(dataInfo,turnTableId,startTurnPage,that);
                } else if (url.indexOf("doExamPaper") >= 0){
                    // 去做试卷功能
                    this.toDoExamPaper(that,dataInfo);
                } else if (url.indexOf("imageCanvas") >= 0) {
                    // 去图片查看功能
                    this.toImageCanvas(that,dataInfo, buttonOne);
                } else if (url.indexOf("toForward") >= 0) {
                    // 去转发功能
                    this.toShareButtonInfo(that,dataInfo, buttonOne);
                } else if (url.indexOf("toDownload") >= 0) {
                    // 直接打开附件按钮
                    var fieldAliasName = url.substring(11);
                    // this.toDownLoadFile(dataInfo, buttonOne, fieldAliasName);
                    this.toOpenFile(that,dataInfo, buttonOne, fieldAliasName);
                } else if (url.indexOf("toOpenFile") >= 0) {
                    // 直接打开文件
                    var fieldAliasName = url.substring(11);
                    this.toOpenFile(that,dataInfo, buttonOne, fieldAliasName);
                }  else if (url.indexOf("toPreviewFile") >= 0) {
                    // 直接预览文件
                    var file = {};
                    file.name = dataInfo.FILE_NAME?dataInfo.FILE_NAME:dataInfo.FILE_DOWNADDRESS;
                    file.downAddress = dataInfo.FILE_DOWNADDRESS;
                    file.backGroundAudio = dataInfo.FILE_BACKGROUND_AUDIO;
                    this.toPreviewFile(that,file,buttonOne);
                } else if (url.indexOf("toOpenCustomer") >= 0){
                    // 打开联系客服页面
                    this.openCustomerPage(that,dataInfo);
                } else if (url.indexOf("toPage") >= 0) {
                    // 打开动态页面 根据dataInfo
                    this.openDynamicPage(that,dataInfo);
                } else if (url.indexOf("toList") >= 0) {
                    var tablePage = url.substring(7);
                    if (tablePage && tablePage.indexOf(":") > 0) {
                        turnTableId = tablePage.split(":")[0];
                        startTurnPage = tablePage.split(":")[1];
                        var mainId = null;
                        if (tablePage.split(":").length > 2) {
                            if (dataInfo.MAIN_ID) {
                                nowDataId = dataInfo.MAIN_ID;
                            }
                            mainId = nowDataId;
                        }
                        // 跳转列表页面
                        var toListJson = {
                            pageId: startTurnPage,
                            tableId: turnTableId,
                            initCheckId: 0,
                            callBackType: 0,
                            dataMaxNum: 0,
                            openWay:openWay,
                            menuName:buttonOne.buttonName
                        }
                        if (mainId) {
                            toListJson.mainId = mainId;
                        }
                        this.toNewListPage(that,toListJson);
                    }
                } else if (url.indexOf("toLook") >= 0) {
                    var tablePage = url.substring(7);
                    if (tablePage && tablePage.indexOf(":") > 0) {
                      turnTableId = tablePage.split(":")[0];
                      startTurnPage = tablePage.split(":")[1];
                      var mainId = 0;
                      if (tablePage.split(":").length > 2) {
                        if (dataInfo.MAIN_ID) {
                          nowDataId = dataInfo.MAIN_ID;
                        }
                        if(tablePage.split(":")[2] > 0) {
                          nowDataId = tablePage.split(":")[2];
                        }
                        mainId = nowDataId;
                      }
                      // 跳转列表页面
                      var toLookJson = {
                        pageId: startTurnPage,
                        tableId: turnTableId,
                        initCheckId: 0,
                        callBackType: 0,
                        dataMaxNum: 1,
                        menuName:buttonOne.buttonName
                      }
                      toLookJson.mainId = mainId;
                      this.toNewLookPage(that,toLookJson);
                    }
                } else if (url.indexOf("toHome") >= 0) {
                    // 去首页
                    this.toMailHome(that);
                } else if (url.indexOf("goBack") >= 0) {
                    // 返回上一页
                    that.$router.back();
                } else if (url.indexOf("loginOut") >= 0){
                    utils.loginOut(that);
                } else if (url.indexOf("toScan") >= 0) {
                    // 调用扫码功能
                    this.toOpenScan(that,buttonOne,url,dataInfo);
                } else if (url.indexOf("toYzEdit") >= 0) {
                    // 调用永中文档在线编辑功能
                    var file = {};
                    file.name = dataInfo.FILE_NAME;
                    file.downAddress = dataInfo.FILE_DOWNADDRESS;
                    file.fileEditType = dataInfo.FILE_EDIT_TYPE;
                    this.toPreviewFile(that,file,buttonOne);
                } else if (url.indexOf("noEvent") >= 0){
                    // 没有后续操作 进行提示
                    if (url.length > 8) {
                        that.$message(url.substring(8));
                    }
                    // 调用自定义js
                    if(buttonOne.jsAfterInvok) {
                        eval(buttonOne.jsAfterInvok);
                    }
                } else if (url.indexOf("toPrint") >= 0){
                    console.log("调用打印--------------------------" + ("kw_print_hidden_button_" + that.pageSetInfo.pageId));
                    // document.getElementById("kw_print_hidden_button_" + that.pageSetInfo.pageId).click();
                    that.toImgPrint();
                    //打印
                    // that.$print(that.$refs.print_kw_box,{'no-print':'.kw_not_print'});
                    // that.setLodop();
                } else if(url.indexOf("toVueExport") >= 0){
                    //前台的vue导出功能
                    this.toVueExport(that,buttonOne);
                } else {
                    // 判断打开方式 onclickType 如果为 弹出层 则打开弹出层 并使用iframe嵌套 如果为 10 VUE新页面或者9 新窗口则打开新页面
                    if(buttonOne.onclickType == 5) {
                        // 弹出层打开 url
                        var paramName = buttonOne.paramName;
                        var paramValue = buttonOne.paramValue;
                        var paramStr = "?isVue=1";
                        if(paramName && paramValue) {
                            var paramNameArr = paramName.split(",");
                            var paramValueArr = paramValue.split(",");
                            for (let index = 0; index < paramNameArr.length; index++) {
                                const paramNameOne = paramNameArr[index];
                                const paramValueOne = paramValueArr[index];
                                paramStr += (paramStr=="?"?'':'&') + paramNameOne + "=" + dataInfo[paramValueOne];
                            }
                        }
                        var dialogInfo = that.dialogInfo;
                        dialogInfo.type = 999;
                        // 获取按钮的参数信息 进行url绑定
                        dialogInfo.url = that.GLOBAL.baseURL + url + paramStr;
                        dialogInfo.sourceOpenThat = that;
                        dialogInfo.pageInfo = {
                            menuName:buttonOne.buttonName
                        }
                        dialogInfo.ifLoad = true;
                        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
                    } else {
                        var paramStr = "";
                        if(url.indexOf("DoExamPaper")>0 || url.indexOf("DoTf")>0) {
                            var paramName = buttonOne.paramName;
                            var paramValue = buttonOne.paramValue;
                            if(paramName && paramValue) {
                                var paramNameArr = paramName.split(",");
                                var paramValueArr = paramValue.split(",");
                                for (let index = 0; index < paramNameArr.length; index++) {
                                    const paramNameOne = paramNameArr[index];
                                    const paramValueOne = paramValueArr[index];
                                    paramStr += "/" + dataInfo[paramValueOne];
                                }
                            }
                        } else {
                            var paramName = buttonOne.paramName;
                            var paramValue = buttonOne.paramValue;
                            if(paramName && paramValue) {
                                paramStr += "?"
                                var paramNameArr = paramName.split(",");
                                var paramValueArr = paramValue.split(",");
                                for (let index = 0; index < paramNameArr.length; index++) {
                                    const paramNameOne = paramNameArr[index];
                                    const paramValueOne = paramValueArr[index];
                                    paramStr += "&" + paramNameOne +"=" + dataInfo[paramValueOne];
                                }
                            }
                        }
                        if(buttonOne.onclickType == 8) {
                            var appPage = that.$router.app.$children[0];
                            var nowPage = appPage.$refs.router_main;
                            if(nowPage.addTab) {
                                var menuOne = {};
                                menuOne.menuName = buttonOne.buttonName;
                                menuOne.actionWay = 1;
                                // 打开后台系统的选项卡
                                menuOne.menuId = "look_" + listTableId + "_" + buttonOne.buttonId + (dataInfo["T_" + that.tableId + "_0"]>0?"_" + dataInfo["T_" + that.tableId + "_0"]:0);
                                menuOne.menuPageUrl = url+paramStr;
                                nowPage.checkTabExists(menuOne);
                            }
                        } else if(buttonOne.onclickType == 10){
                            window.open(url+paramStr);
                        } else {
                            window.location.href=url+paramStr;
                        }
                        // window.open(url+paramStr);
                    }
                } 
            } else if (buttonType == 23) {
                //直接下载按钮
                var fileId = dataInfo.FILE_ID;
                if (fileId == null || fileId.length == 0) {
                    that.$message("无相关文件");
                    return;
                }
                //查找FILE_ID 的字段 进行附件预览页面的打开
                // wx.navigateTo({
                //     url: '../../template/fileLook?fileId=' + fileId + '&ifUpdate=0&callBackIndex=0'
                // });
    
            } else if (buttonType == 0) {
                //添加按钮
                //关联添加功能
                var jumpJson = {
                    pageId: startTurnPage,
                    tableId: turnTableId,
                    mainId: nowDataId,
                    callBackType: 1,
                    listTableId: listTableId,
                    pageType:5,
                    menuName:buttonOne.buttonName
                };
                this.toNewLookPage(that,jumpJson);
            } else if (buttonType == 3) {
                //批量删除功能
                //获取要删除的选中数据 如果没有提示请选中数据 如果有则提示是否删除 如果选择是则调用删除功能
                var pageDataInfo = that.pageDataInfo;
                var checkedId = '';
                if(that.$refs.kw_list_default) {
                    var kw_list_default = typeof(that.$refs.kw_list_default.length)=='number'?that.$refs.kw_list_default[0]:that.$refs.kw_list_default;
                    if(kw_list_default && kw_list_default.selectionNodes.length > 0) {
                        var tableId = that.tableId;
                        kw_list_default.selectionNodes.forEach(dataInfo => {
                            checkedId += (checkedId==""?"":",") + dataInfo["T_" + tableId + "_0"]
                        });
                    }
                } else {
                    if(that.pageDataInfo) {
                        that.pageDataInfo.forEach(dataInfo => {
                            if(dataInfo.RADIO_CHECK_STATE) {
                                checkedId += (checkedId==""?"":",") + dataInfo["T_" + that.tableId + "_0"]
                            }
                        });
                    }
                }
                if (checkedId == "") {
                    that.$message({
                        showClose: true,
                        message: '请选中数据进行批量删除！',
                        type: 'error'
                    });
                } else {
                    this.deleteDataById(checkedId, that, buttonType);
                }
            } else if (buttonType == 2) {
                //批量修改功能
                var checkedId = '';
                if(that.$refs.kw_list_default) {
                    var kw_list_default = typeof(that.$refs.kw_list_default.length)=='number'?that.$refs.kw_list_default[0]:that.$refs.kw_list_default;
                    if(kw_list_default && kw_list_default.selectionNodes.length > 0) {
                        var tableId = that.tableId;
                        kw_list_default.selectionNodes.forEach(dataInfo => {
                            checkedId += (checkedId==""?"":",") + dataInfo["T_" + tableId + "_0"]
                        });
                    }
                } else {
                    if(that.pageDataInfo) {
                        that.pageDataInfo.forEach(dataInfo => {
                            if(dataInfo.RADIO_CHECK_STATE) {
                                checkedId += (checkedId==""?"":",") + dataInfo["T_" + that.tableId + "_0"]
                            }
                        });
                    }
                }
                if (checkedId == "") {
                    that.$message({
                        showClose: true,
                        message: '请选中数据进行批量修改！',
                        type: 'error'
                    });
                } else {
                    //跳转至 批量修改页面
                    var jumpJson = {
                        pageId: startTurnPage,
                        tableId: listTableId,
                        mainId: checkedId,
                        pageType:8,
                        callBackType: 1
                    };
    
                    this.toNewLookPage(that,jumpJson);
                }
            } else if (buttonType == 9) {
                // 自定义按钮 
                var startTurnPageUrl = buttonOne.startTurnPageUrl;
                if (startTurnPageUrl.indexOf("http") >= 0) {
                // 打开网页
                } else if (startTurnPageUrl.indexOf("openFieldDialog") >= 0) {
                    // 打开关联页面的 某个字段的弹出层
                    var fieldId = startTurnPageUrl.replace("openFieldDialog:","");
                    var myEventDetail = {
                        clickType: 1,
                        fieldId: fieldId
                    }
                    that.$emit("zdyParentEvent",myEventDetail);
                    } else if (startTurnPageUrl.indexOf("openList") >= 0) {
                    var pageInfo = that.pageSetInfo;
                    var styleSet = pageInfo.listStyleSet;
                    //跳转到具体的列表页面   需要把搜索条件传递过去
                    var toListJson = {
                        pageId: styleSet.jumpPageId,
                        tableId: styleSet.jumpTableId,
                        initCheckId: 0,
                        callBackType: 0,
                        dataMaxNum: 1
                    }
                    this.toNewListPage(that,toListJson);
                }
            } else if (buttonType == 5) {
                // 导出按钮
                var toHtData = {};
                that.loadDataSearchHandle(toHtData);
                var url = "export_export.do?";
                // var params = this.jsonToParamStr(toHtData);
                this.downLoadFile(url,toHtData,that.pageSetInfo.pageName+".xls",that);
            } else if(buttonType == 4) {
                // 导入按钮
                // 显示文件上传按钮 和 导出模板按钮
                that.importDialogInfo.buttonOne = buttonOne;
                var toHtData = that.getToImportParamJson("upload");
                toHtData.tableId = that.tableId;
                that.importDialogInfo.uploadData = toHtData;
                console.log("importDialogInfo.uploadData========================",toHtData);
                that.importDialogInfo.ifLoad = true;
            }
        }
    },

    /**
     * 直接操作的方法
     */
    dicrectTrigger: function (nowDataId, that, buttonType, directSetIds, operaPrompt, listTableId, buttonSetOne, dataInfo) {
        if(buttonSetOne.ifAlert == 1) {
            this.dicrectTriggerExe(nowDataId, that, buttonType, directSetIds, listTableId, buttonSetOne, dataInfo);
        } else {
            if (operaPrompt == "" || operaPrompt == undefined) {
                operaPrompt = "确定要进行操作么？";
            } 
            that.$confirm(operaPrompt, '确认提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dicrectTriggerExe(nowDataId, that, buttonType, directSetIds, listTableId, buttonSetOne, dataInfo);
            }).catch(() => {
            });
        }
    },
    
    dicrectTriggerExe: function (nowDataId, that, buttonType, directSetIds, listTableId, buttonSetOne, dataInfo){
        var toHtData = {};
        toHtData.tableId = listTableId;
        toHtData.pageId = 0;
        toHtData.directSetIds = directSetIds;
        if(buttonSetOne.styleSet && buttonSetOne.styleSet.ifNoLogin==1) {
            toHtData.source="kw_20190771"
        }
        toHtData.dataIds = nowDataId;
        toHtData.buttonType = buttonType;
        var pageUtils = this;
        that.loading = true;
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
            url: 'update_dicrectTrigger.do',
            data: toHtData,
            success: function (res) {
                that.loading = false;
                var successFlag = false;
                if (typeof res.data == "object") {
                    if(res.data.ID > 0) {
                        successFlag = true;
                    }
                } else if (res.data != 0) {
                    successFlag = true;
                }
                var styleSet = buttonSetOne.styleSet;
                var delayMillisecond = 3000;
                if(styleSet && styleSet.delayMillisecond > 0) {
                    delayMillisecond = styleSet.delayMillisecond;
                }
                if (!successFlag) {
                    //如果不成功则 提示失败原因
                    var errorReason = "操作失败,请重试或联系老师!";
                    if (res.data.message) {
                        errorReason = res.data.message;
                    }
                    that.$message({
                        showClose: true,
                        message: errorReason,
                        type: 'error',
                        duration:delayMillisecond
                    });
                } else {
                    var succesReason = "操作成功!";

                     /*
                    * 此处判断展现形式设置后续操作设置 等于 报名成功弹窗(tyoe=9)
                    * 不执行element $message, 执行自定义弹窗
                    * */
                    let OperaType = ''
                    if(buttonSetOne.styleSet && ((typeof buttonSetOne.styleSet.nextOperaType) !== 'undefined') && buttonSetOne.styleSet.nextOperaType === '9') {
                        OperaType = buttonSetOne.styleSet.nextOperaType;
                    }
                    if(!styleSet || styleSet.ifShowDialog != 2) {
                        that.$message({
                            showClose: true,
                            message: succesReason,
                            type: 'success',
                            duration:delayMillisecond
                        });
                    }
                    //刷新列表
                    if (styleSet.delayMillisecond > 0) {
                        setTimeout(function () {
                            if(that.refreshevent) {
                                that.refreshevent();
                            } else {
                                that.$emit("refreshevent");
                            }
                        }, styleSet.delayMillisecond);
                    } else {
                        if(that.refreshevent) {
                            that.refreshevent();
                        } else {
                            that.$emit("refreshevent");
                        }
                    }
                    //根据后续操作进行页面跳转

                    if (styleSet && styleSet.nextOperaType == 1) {
                        //获取当前的页面 进行刷新
                        var kw_look = null;
                        that.getParentKwLook(val => {
                            kw_look = val
                        });
                        if(kw_look) {
                            kw_look.refreshevent();
                        }
                    } else {
                        var tableId = styleSet.clickTableId;
                        var pageId = styleSet.clickPageId;
                        var mainId = 0;
                        var resJson = {};
                        if (typeof res.data == "object") {
                            resJson = res.data;
                            mainId = resJson.ID;
                            if (resJson.tableId > 0) {
                                tableId = resJson.tableId;
                            }
                            if (resJson.pageId > 0) {
                                pageId = resJson.pageId;
                            }
                        }
                        if (tableId > 0 && pageId > 0 && mainId > 0) {
                            if (styleSet.nextOperaType == 2) {
                                // 跳转详情页
                                var jumpJson = {
                                    pageId: pageId,
                                    tableId: tableId,
                                    mainId: mainId,
                                    callBackType: 1,
                                    listTableId: tableId,
                                    ifInitZdy: true
                                };
                                // 后续打开的页面是否走自定义js
                                if (styleSet.nextOperaIfZdy == 1) {
                                    jumpJson.ifInitZdy = true;
                                }
                                if (styleSet.delayMillisecond > 0) {
                                    setTimeout(function () {
                                        pageUtils.toNewLookPage(that,jumpJson);
                                    }, styleSet.delayMillisecond);
                                } else {
                                    pageUtils.toNewLookPage(that,jumpJson);
                                }
                            } else if (styleSet.nextOperaType == 3) {
                                // 跳转列表页面
                                var toListJson = {
                                    pageId: pageId,
                                    tableId: tableId,
                                    initCheckId: 0,
                                    callBackType: 0,
                                    dataMaxNum: 1
                                }
                                if (styleSet.delayMillisecond > 0) {
                                    setTimeout(function () {
                                        pageUtils.toNewListPage(that,toListJson);
                                    }, styleSet.delayMillisecond);
                                } else {
                                    pageUtils.toNewListPage(that,toListJson);
                                }
                            } 
                        }
                        if (styleSet.nextOperaType == 5) {
                            pageUtils.openCustomerPage(that,resJson);
                        } else if (styleSet.nextOperaType == 6) {
                            // 打开二维码分享页面
                            pageUtils.toImageCanvas(that,dataInfo, buttonSetOne);
                        } else if (styleSet.nextOperaType == 11) {
                            //关闭本页 返回上一页 并进行上一页的重新加载刷新
                            that.$emit("goBack",1);
                        } else if(styleSet.nextOperaType == 12) {
                            //刷新最外层查看页面的子选项卡列表
                            var kw_look = null;
                            that.getParentKwLook(val => {
                                kw_look = val
                            });
                            if(kw_look) {
                                var pageSetInfo = kw_look.pageSetInfo;
                                if(pageSetInfo.tabPageSet){
                                    for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
                                      if(kw_look.$refs["kw_list_" + i] && kw_look.$refs["kw_list_" + i].length>0) {
                                        kw_look.$refs["kw_list_" + i][0].initLoadDataInfo();
                                      }
                                      if(kw_look.$refs["tabPageSet_kw_look_" + i] && kw_look.$refs["tabPageSet_kw_look_" + i].length>0) {
                                        kw_look.$refs["tabPageSet_kw_look_" + i][0].initAtiached();
                                      }
                                    }
                                  }
                            }
                        }
            
                    }
                } 
            }
        })
    },

    /**
     * 打开一个新页签
     */
    xcxOpenUrl:function(url,that){
        if(utils.isNotNull(localStorage.loginInfo)) {
            var loginInfo = JSON.parse(localStorage.loginInfo);
            var number = '100000000' + loginInfo.USERID;
            var name = loginInfo.USERNAME;
            var newUrl = url + "&nickname=" + name + "&uid=" + number + "&wxx=true";
            window.location.href = newUrl;
        } else {
            that.$router.app.$children[0].openLogin(null);
        }
    },

    /**
     * 进入展示互动直播间
    */
    goToGensee: function (one,that) {
        var STU_URL = one.STU_URL;
        var CLIENT_TOKEN = one.CLIENT_TOKEN;
        var url = STU_URL + "?" + (CLIENT_TOKEN ? '&token=' + CLIENT_TOKEN : '');
        this.xcxOpenUrl(url,that);
    },
    /**
     * 进入展示互动回看地址
    */
    goToGenseeCourseWare: function (one,that) {
        var STU_URL = one.HK_URL;
        var CLIENT_TOKEN = one.HK_TOKEN;
        var url = STU_URL+ "?" + (CLIENT_TOKEN ? '&token=' + CLIENT_TOKEN : '');
        this.xcxOpenUrl(url,that);
    },
    /**
     * 跳转到 百家云播放地址
     */
    goToBjyLive:function(dataInfo,turnTableId,startTurnPage,that){
        var teaurl = "https://study.bailiedu.com/qcbl_edus_auto/baijiayun.jsp";
        teaurl += '?room_id='+dataInfo.ROOM_ID;
        if(utils.isNotNull(localStorage.loginInfo)) {
            var loginInfo = JSON.parse(localStorage.loginInfo);
            var number = loginInfo.USERID;
            var name = loginInfo.USERNAME;
            var newUrl = teaurl + "&user_name=" + name + "&user_id=" + number + "&user_role=0";
            if(utils.checkVisitSource() == 2) {
                newUrl+="&jr_type=0";
            } else {
                newUrl+="&jr_type=1";
            }
            window.location.href = newUrl;
        } else {
            that.$router.app.$children[0].openLogin(null);
        }
    },
    /**
     * 跳转到 做试卷页面
     */
    toDoExamPaper:function(that,one){
        var proId = that.GLOBAL.proId;
        if(localStorage.domain_name && localStorage.domain_name != "" && that.GLOBAL.proIdJson[localStorage.domain_name]) {
            toHtData.proId = that.GLOBAL.proIdJson[localStorage.domain_name];
        }
        if (proId.indexOf("/")) {
            proId = proId.substring(0, proId.indexOf("/"));
        }
        var params = {};
        params.proId = proId;
        params.initShowType = one.SHOW_TYPE?one.SHOW_TYPE:(one.ZD_IF_DO==1?5:3);
        params.initExamPaperId = one.EXAM_PAPER_ID
        params.initStuId = localStorage.USERID;
        params.initStudentExamPaperId = one.S_E_P_ID;
        this.toNewDoExamPaper(that,params);
    },
    
    /**
     * 打开动态页面 根据dataInfo中的 TABLE_ID PAGE_ID PAGE_TYPE
     */
    openDynamicPage: function (that,dataInfo){
        var userId = 0;
        // 登录人的信息
        if(utils.isNotNull(localStorage.loginInfo)) {
            var loginInfo = JSON.parse(localStorage.loginInfo);
            userId = loginInfo.USERID;
        }
        if (!(userId > 0)) {
            // that.openLogin();
        } 
        // 去列表页面
        var turnTableId = dataInfo.TABLE_ID;
        var startTurnPage = dataInfo.PAGE_ID;
        var cellContainerOpenMode = 0;
        if(that.pageSetInfo.listStyleSet && that.pageSetInfo.listStyleSet.cellContainerOpenMode) {
            cellContainerOpenMode = that.pageSetInfo.listStyleSet.cellContainerOpenMode
        }
        if (dataInfo.PAGE_TYPE == 1) {
            // 跳转列表页面
            var toListJson = {
                pageId: startTurnPage,
                tableId: turnTableId,
                initCheckId: 0,
                callBackType: 0,
                dataMaxNum: 1
            }
            if(cellContainerOpenMode == 1) {
                that.rightPageInfo.ifLoad = false;
                that.$nextTick(function(){
                    toListJson.type = 1;
                    toListJson.ifLoad = true;
                    that.rightPageInfo = toListJson;
                })
            } else {
                this.toNewListPage(that,toListJson);
            }
        } else if (dataInfo.PAGE_TYPE == 11 || dataInfo.PAGE_TYPE == 7 || dataInfo.PAGE_TYPE == "updatePsw") {
            var mainId = userId;
            if (dataInfo.MAIN_ID > 0) {
                mainId = dataInfo.MAIN_ID;
            }
            var shamOpenId = pageUtils.getShamOpenId();
            if(shamOpenId>0 && !mainId) {
                mainId = shamOpenId;
            }
            var jumpJson = {
                pageId: startTurnPage,
                tableId: turnTableId,
                mainId: mainId,
                callBackType: 1
            };
            if(cellContainerOpenMode == 1) {
                that.rightPageInfo.ifLoad = false;
                that.$nextTick(function(){
                    jumpJson.type = 11;
                    jumpJson.ifLoad = true;
                    jumpJson.pageType = dataInfo.PAGE_TYPE;
                    that.rightPageInfo = jumpJson;
                })
            } else {
                this.toNewLookPage(that,jumpJson);
            }
        } else if (dataInfo.PAGE_TYPE == "toOpenCustomer") {
            // 打开联系客服页面
            this.openCustomerPage(that,dataInfo);
        } else if (dataInfo.PAGE_TYPE == "loginOut") {
            utils.loginOut(that);
        }
    },
    /**
     * 点击删除时进行数据删除
     */
    deleteDataById(checkedId, that, buttonType, operaPrompt){
        var pageUtils = this;
        if (checkedId == "") {
            that.$message({
                showClose: true,
                message: '请选中需要删除的数据,再进行删除操作!',
                type: 'error'
            });
        } else {
            that.$confirm('确定要删除选中的数据么？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var tableId = that.pageSetInfo.tableId;
                var pageId = that.pageSetInfo.pageId;
                var url = "delete_delete.do";
                //进行后台数据删除
                var toHtData = {};
                toHtData.tableId = tableId;
                toHtData.pageId = pageId;
                toHtData.delIds = checkedId;
                toHtData.buttonType = buttonType;
                that.loading = true;

                utils.request(that,{
                    url: url,
                    data: toHtData,
                    success: function (res) {
                        that.loading = false;
                        if (res.data != null) {
                            that.$message({
                                type: 'info',
                                message: res.data
                            }); 
                            // 判断页面类型 如果是查看修改页面 调用返回上一页
                            if (that.pageType == 11 || that.pageType == 7) {
                                pageUtils.navigateBack(that);
                            } else {
                                //刷新列表
                                if(that.refreshevent) {
                                    that.refreshevent();
                                } else {
                                    that.$emit("refreshevent");
                                }
                            }
                        }
                    }
                })
            }).catch(() => {
                that.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    /**
     * 列表组件中 列表数据点击时 事件
     */
    listDataClick: function (that, dataInfo, otherJson){
        var pageSetInfo = that.pageSetInfo;
        var styleSet = pageSetInfo.listStyleSet;
        if (styleSet) {
            if (styleSet.clickType == 1) {
                //点击事件设置无时 调用第一个显示的按钮的点击事件
                this.dataListButtonClick(that,dataInfo);
            } else if (styleSet.clickType == 2) {
                //加载详情页
                var detailPageInfo = {};
                detailPageInfo.ifLoaded = false;
                that.detailPageInfo = detailPageInfo;
                var clickPageId = styleSet.clickPageId;
                var clickTableId = styleSet.clickTableId;
                var jumpMainId = that.oneCurrent;
                if (!styleSet.clickPageId && !styleSet.clickTableId) {
                    var tmpMap = this.getOneButtonInfo(that,dataInfo);
                    console.log("tmpMap================",tmpMap);
                    clickPageId = tmpMap.pageId;
                    clickTableId = tmpMap.tableId;
                    var relationField = tmpMap.relationField;
                    if (dataInfo[relationField] > 0) {
                        jumpMainId = dataInfo[relationField];
                    } else {
                        jumpMainId = that.mainId;
                        if(!jumpMainId) {
                            jumpMainId = this.getShamOpenId()*1;
                        }
                    }
                }
                that.$nextTick(function(){
                    detailPageInfo = {
                        pageId: clickPageId,
                        tableId: clickTableId,
                        pageType: 11,
                        listTableId: clickTableId,
                        mainId: jumpMainId,
                        ifLoaded: true
                    };
                    that.detailPageInfo = detailPageInfo;
                });
            } else if (styleSet.clickType == 3 || styleSet.clickType == 5) {
                // 跳转到列表页面
                var clickPageId = styleSet.clickPageId;
                var clickTableId = styleSet.clickTableId;
                // 来源的页面的主键信息
                var initCheckId = 0;
                if (styleSet.clickType == 5) {
                var mainId = dataInfo["T_" + styleSet.clickTableId + "_0"];
                if(mainId > 0) {
                    initCheckId = mainId;
                }
                }
                var toListJson = {
                    pageId: clickPageId,
                    tableId: clickTableId,
                    initCheckId: initCheckId,
                    callBackType: 0,
                    dataMaxNum: 1
                }
                if (otherJson) {
                    //关闭当前页 跳转
                    if (otherJson.jumpWay == 1) {
                        toListJson.jumpWay = 1;
                    }
                    // 默认传递的搜索条件
                    if (otherJson.initSearchVal && otherJson.initSearchVal.length > 0) {
                        toListJson.initSearchVal = otherJson.initSearchVal;
                    }
                }
                //判断是否有 传递的默认搜索条件 如果有则进行穿度
                this.toNewListPage(that,toListJson);
            } else if (styleSet.clickType == 4) {
                var mainId = dataInfo["T_" + styleSet.clickTableId + "_0"]
                var jumpJson = {
                    pageId: styleSet.clickPageId,
                    tableId: styleSet.clickTableId,
                    mainId: mainId,
                    callBackType: 1
                };
                this.toNewLookPage(that,jumpJson);
            } else if(styleSet.clickType == 6) {
                var clickPageId = styleSet.clickPageId;
                var clickTableId = styleSet.clickTableId;
                // 来源的页面的主键信息
                var initCheckId = 0;
                if (styleSet.clickType == 5) {
                var mainId = dataInfo["T_" + styleSet.clickTableId + "_0"];
                if(mainId > 0) {
                    initCheckId = mainId;
                }
                }
                var toListJson = {
                    pageId: clickPageId,
                    tableId: clickTableId,
                    initCheckId: initCheckId,
                    callBackType: 0,
                    dataMaxNum: 1
                }
                // 后台选项卡打开列表
                // 打开后台系统的选项卡
                toListJson.menuId = "look_" + toListJson.tableId + "_" + toListJson.pageId + (toListJson.mainId>0?"_" + toListJson.mainId:0);
                // toListJson.url = "look?noHead=1&kw_param=" + kwParam;
                var appPage = that.$router.app.$children[0];
                var nowPage = appPage.$refs.router_main;
                nowPage.checkTabExists(toListJson);
            } else if(styleSet.clickType == 7) {
                var clickPageId = styleSet.clickPageId;
                var clickTableId = styleSet.clickTableId;
                // 来源的页面的主键信息
                var initCheckId = 0;
                var mainId = dataInfo["T_" + styleSet.clickTableId + "_0"];
                if(mainId > 0) {
                    initCheckId = mainId;
                }
                if(initCheckId > 0) {
                    var toListJson = {
                        pageId: clickPageId,
                        tableId: clickTableId,
                        mainId: initCheckId,
                        openWay:5,
                        menuName:dataInfo.NAME,
                        pageType:11,
                        callBackType: 0
                    }
                    this.toNewLookPage(that,toListJson);
                }
            }
        }
        // 
        if (that.eventTrigger) {
            that.eventTrigger();
        } else if(that.dataMaxNum == 1) {
            var tableId = that.pageSetInfo.tableId;
            var myEventDetail = {} // detail对象，提供给事件监听函数
            if(dataInfo != null) {
                myEventDetail = {
                    val: dataInfo["T_" + tableId + "_0"],
                    checkDataInfo: [dataInfo]
                }
            } else {
                myEventDetail = {
                    val: '',
                    checkDataInfo: []
                }
            }
            that.$emit("callbackevent", myEventDetail);
        } else if(that.dataMaxNum != 1) {
            //默认调用 复选框的选中
            dataInfo.RADIO_CHECK_STATE = !dataInfo.RADIO_CHECK_STATE;
            that.$forceUpdate();
        }
    },
    /**
     * 默认调用列表的第一个显示的按钮
     */
    dataListButtonClick: function  (that,dataInfo) {
        var oneIndex = that.oneIndex;
        var operaButtonSet = that.pageSetInfo.operaButtonSet;
        var dataList = that.dataList;
        if(!dataInfo) {
            dataInfo = dataList[oneIndex];
        }
        if (operaButtonSet) {
            var flag = true;
            operaButtonSet.forEach((buttonItem, index) => {
                if (buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0) && flag) {
                    var e = {
                        currentTarget: {
                            dataset: {
                                buttonindex: index,
                                fieldindex: oneIndex
                            }
                        }
                    }
                    this.dataButtonClick(that,buttonItem,dataInfo);
                    flag = false;
                    return;
                }
            });
        }
    },

    /**
     * 默认获取第一个按钮的页面信息
     */
    getOneButtonInfo: function  (that,dataInfo) {
        var oneIndex = that.oneIndex;
        var operaButtonSet = that.pageSetInfo.operaButtonSet;
        var dataList = that.dataList;
        if(!dataInfo) {
            dataInfo = dataList[oneIndex];
        }
        var detailPageInfo = { flag: false };
        if (operaButtonSet) {
            operaButtonSet.forEach((buttonItem, index) => {
                if (!detailPageInfo.flag) {
                    if (buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0)) {
                        detailPageInfo.tableId = buttonItem.tableId;
                        detailPageInfo.pageId = buttonItem.startTurnPage;
                        detailPageInfo.relationField = buttonItem.relationField;
                        detailPageInfo.flag = true;
                    }
                }
            });
        }
        return detailPageInfo;
    },

    /**
     * 获取需要保存到后台的数据信息
     */
    getToHtData: function (that,floorIndex,ifCheckValid) {
        var toHtData = {};
        //循环字段 进行
        var pageSetInfo = that.pageSetInfo;
        var fieldSet = pageSetInfo.fieldSet;
        var mainDataId = that.mainId;
        var pageType = that.pageType;
        toHtData.tableId = that.tableId;
        toHtData.pageId = that.pageId;
        toHtData.pageType = pageType;
        if(floorIndex == 0) {
            //传递 是否执行触发器  触发器执行顺序
            if(pageSetInfo.ifTrigger) {
                toHtData.ifTrigger = pageSetInfo.ifTrigger;
            }
            if(pageSetInfo.triggerOrder) {
                toHtData.triggerOrder = pageSetInfo.triggerOrder;
            }
        }
        if (mainDataId) {
            toHtData.mainDataId = mainDataId;
            if(pageType == 5) {
                toHtData.mainWjId = mainDataId;
            }
        } else {
            toHtData.mainDataId = "";
        }
        for (var i = 0; i < fieldSet.length; i++) {
            var element = fieldSet[i];
            //判断一下如果是排课组件则进行一次 保存前的渲染
            // if(element.styleSet && element.styleSet.showStyle==33){
            //     //this.confirmDialogCallBack(that,element, element.prevFieldIndex+':'+element.nowFieldIndex+'-'+0, true);
            //     console.log("that.$refs.kw_make_schedule===================",that.$refs.kw_make_schedule);
            //     that.$refs.kw_make_schedule[0].refreshScheduleData();
            // }
            // fieldSet.forEach(element => {
            //判断字段类型 如果是21：内部对象多值 则进行子表格数据的处理
            var tmpVal = element.defaultValStr;
            // 如果是单值选择项  弹出层类型 附件类型
            if (element.fieldType>3 && element.fieldType!=6) {
                tmpVal = element.defaultCheckValue ? element.defaultCheckValue:'';
            }
            if (tmpVal == undefined || tmpVal == "undefined") {
                tmpVal = "";
            }
            
            if (element.fieldRole == 17) {
                var tmpId = "";
                var tmpValArr = tmpVal.split(",");
                tmpValArr.forEach(valElement => {
                    if (tmpId != "") {
                        tmpId += ",";
                    }
                    tmpId += valElement;
                });
                //多值选择项
                if (element.zdyAliasName) {
                    toHtData[element.zdyAliasName] = tmpId;
                } else {
                    toHtData['t' + floorIndex + '_' + element.inputFName] = tmpId;
                }
            } else if (element.fieldRole == 19) {
                //多文档
                if (element.zdyAliasName) {
                    toHtData[element.zdyAliasName] = tmpVal;
                } else {
                    toHtData['t' + floorIndex + '_' + element.inputFName + '_file_many'] = tmpVal;
                }
            } else if (element.fieldRole == 20) {
                if (element.zdyAliasName) {
                    toHtData[element.zdyAliasName] = tmpVal;
                } else {
                    toHtData['t' + floorIndex + '_' + element.inputFName] = tmpVal;
                }
            } else if (element.fieldRole == 21) {
                //内部对象多值的个数
                if (element.childPageJsonArr) {
                    var tmpNum = element.childPageJsonArr.length;
                    if (tmpNum == null || tmpNum == undefined) {
                        if (tmpVal == "") {
                            tmpNum = 0;
                        } else {
                            tmpNum = (tmpVal + '').split(",").length;
                        }
                    }
                    if (element.zdyAliasName) {
                        toHtData['dzLmf_'+element.zdyAliasName] = tmpNum;
                    } else {
                        toHtData['dzLmf_'+'t' + floorIndex + '_' + element.dialogFName + '_dz'] = tmpNum;
                    }
                    if (tmpVal != null && tmpVal != undefined) {
                        if(element.addStyle != 3) {
                            if (element.zdyAliasName) {
                                toHtData['dzLmf_'+element.zdyAliasName + "_ID"] = (tmpVal + '').replace(/,/g, "♆");
                            } else {
                                toHtData['dzLmf_'+'t' + (floorIndex + 1) + '_' + element.dialogIdName] = (tmpVal + '').replace(/,/g, "♆");
                            }
                        }
                        var updateIdName = element.updateIdName;
                        var childKWLookArr = element.childPageJsonArr;//that.$refs["kw_look_" + element.fieldId];
                        if (childKWLookArr) {
                            for (let index = 0; index < childKWLookArr.length; index++) {
                                var childKWLookOne = childKWLookArr[index];
                                var tmpChildThat = that.$refs["kw_look_" + element.fieldId + "_" + index];
                                var childThat = null;
                                var ifHasChild = false;
                                if(tmpChildThat) {
                                    childThat = (tmpChildThat.length > 0)?tmpChildThat[0]:tmpChildThat;
                                    ifHasChild = true;
                                } else {
                                    childThat = {
                                        "pageSetInfo":childKWLookOne,
                                        "mainId":childKWLookOne.updateDataId,
                                        "pageType":null,
                                        "tableId":null,
                                        "pageId":null,
                                        "WxValidate":that.WxValidate
                                    }
                                    ifHasChild = false;
                                }
                                var childToHtData = this.getToHtData(childThat, floorIndex+1);
                                // console.log("childToHtData=============================",childToHtData);
                                if(element.pxObject && element.pxObject.inputFName) {
                                    if (element.pxObject.zdyAliasName) {
                                        childToHtData[element.pxObject.zdyAliasName] = (index+1);
                                    } else {
                                        childToHtData['t' + (floorIndex+1) + '_' + element.pxObject.inputFName] = (index+1);
                                    }
                                }
                                for (var tmpKey in childToHtData) {
                                    if (tmpKey == "mainDataId") {
                                        var childUpdateKey = 't' + (floorIndex + 1) + '_' + updateIdName;
                                        if(element.zdyAliasName) {
                                            childUpdateKey = element.zdyAliasName + "_mainID";
                                        }
                                        if (toHtData[childUpdateKey] == undefined) {
                                            toHtData[childUpdateKey] = "";
                                        } else {
                                            if(toHtData[childUpdateKey] != "") {
                                                toHtData[childUpdateKey] += "♆";
                                            }
                                        }
                                        toHtData[childUpdateKey] += childToHtData[tmpKey];
                                    } else if(tmpKey.startsWith("dzLmf_")) {
                                        if (toHtData[tmpKey] == undefined || toHtData[tmpKey] == null) {
                                            toHtData[tmpKey] = "";
                                        } else {
                                            if(toHtData[tmpKey] != "" && (childToHtData[tmpKey]+"").length > 0) {
                                                toHtData[tmpKey] += "♆";
                                            }
                                        }
                                        toHtData[tmpKey] += childToHtData[tmpKey];
                                    } else if (tmpKey != "tableId" && tmpKey != "pageId" && tmpKey != "pageType" && tmpKey != "pxAliasName") {
                                        if (toHtData[tmpKey] == undefined || toHtData[tmpKey] == null) {
                                            toHtData[tmpKey] = "";
                                        } else {
                                            // if(toHtData[tmpKey] != "" && (childToHtData[tmpKey]+"").length > 0) {
                                                toHtData[tmpKey] += "♆";
                                            // }
                                        }
                                        toHtData[tmpKey] += childToHtData[tmpKey];
                                    } 
                                }
                                if(ifHasChild) {
                                    //判断子表格的校验是否通过
                                    childThat.$refs['look_form_'+childThat.pageId].validate((valid) => {
                                            if (valid) {
                                                console.log('通过');
                                            } else {
                                                childToHtData.errorMessage = "校验不通过";
                                                return false;
                                            }
                                        }
                                    )
                                    if (childToHtData.errorMessage != null && childToHtData.errorMessage!="") {
                                        toHtData.errorMessage = childToHtData.errorMessage;
                                        break;
                                    }
                                }
                            }
                        } else {
                            //没有子表格 如果是修改则 获取修改的主键 _upDataId
                            var tmpUpdateId = element.defaultCheckUpdateId;
                            if (tmpUpdateId == undefined) {
                                tmpUpdateId = "";
                            }
                            if (element.zdyAliasName) {
                                toHtData['dzLmf_'+element.zdyAliasName + "_mainId"] = (tmpUpdateId + '').replace(/,/g, "♆");
                            } else {
                                toHtData['dzLmf_'+'t' + (floorIndex + 1) + '_' + updateIdName] = (tmpUpdateId + '').replace(/,/g, "♆");
                            }
                        }
                    }
                    tmpVal = tmpNum;
                } else {
                    if (element.zdyAliasName) {
                        toHtData[element.zdyAliasName] = 0;
                    } else {
                        toHtData['t' + floorIndex + '_' + element.dialogFName + '_dz'] = 0;
                    }
                    tmpVal = 0;
                }
                //t0_au_35_75_328
            } else if (element.fieldRole == 2) {
                if(element.EDITOR_ID > 0) {
                    tmpVal = element.EDITOR_ID + "_wqy_editor_" + tmpVal
                }
                if (element.zdyAliasName) {
                    toHtData[element.zdyAliasName] = tmpVal;
                } else {
                    toHtData['t' + floorIndex + '_' + element.inputFName + "_editor"] = tmpVal;
                }
            } else {
                if (element.zdyAliasName) {
                    toHtData[element.zdyAliasName] = tmpVal;
                } else {
                    toHtData['t' + floorIndex + '_' + element.inputFName] = tmpVal;
                }
            }
            
            // if (element.rules && !element.ifHide) {
            //     if(that.WxValidate) {
            //         var errorMessage = that.WxValidate.checkParamZdy(tmpVal, element.rules, element.messages);
            //         if (errorMessage != null && errorMessage!="") {
            //             //校验失败
            //             toHtData.errorMessage = errorMessage;
            //             break;
            //         }
            //     }
            // }
            
        }
        if(floorIndex == 0) {
            for (var tmpKey in toHtData) {
                if(tmpKey.startsWith("dzLmf_")) {
                    toHtData[tmpKey.substring(6)] = toHtData[tmpKey];
                    delete toHtData[tmpKey];
                }
            }
        }
        // 判断 是否能通过校验  that
        if(floorIndex == 0 && ifCheckValid==null) {
            // that.$refs['look_form_'+that.pageId].validate((valid) => {
            //     if (valid) {
            //         console.log('通过');
            //     } else {
            //         toHtData.errorMessage = "校验不通过";
            //         return false;
            //     }
            // })
            // async function toFormValidateYb(that,toHtData){
            //     // await pageUtils.toFormValidate(that).then(res=>{
            //     //     toHtData.errorMessage = res;
            //     // });
            //     // await new Promise((resolve,reject)=>{
            //         const v = await that.$refs['look_form_'+that.pageId].validate().then((valid) => {
            //             var tmperrorMessage = "";
            //             if (valid) {
            //                 console.log('通过');
            //                 tmperrorMessage = '';
            //             } else {
            //                 tmperrorMessage = '校验不通过';
            //             }
            //             console.log("tmperrorMessage=====================",tmperrorMessage);
            //             return resolve(tmperrorMessage);
            //             // toHtData.errorMessage = tmperrorMessage;
            //         })
            //         console.log("v==========",v);
            //     // })
            // };
            // console.log("开始调用");
            // var tmp = await pageUtils.toFormValidate(that,toHtData).then(v=>{
            //     console.log("v=================",v);
            // });
            // console.log("tmp=================",tmp);
            // .then(res=>{
            //     console.log("res----------------------------",res);
            //     toHtData.errorMessage = res;
            // });
        }
        console.log("toHtData==========保存前获取===========",JSON.stringify(toHtData));
        return toHtData;
    },

    /**
     * 后台校验的方法
     */
     toFormValidate:async function(that){
        // const v = await that.$refs['look_form_'+that.pageId].validate((valid) => {
        //         var tmperrorMessage = "";
        //         if (valid) {
        //             console.log('通过');
        //             tmperrorMessage = '';
        //         } else {
        //             tmperrorMessage = '校验不通过';
        //         }
        //         console.log("tmperrorMessage=====================",tmperrorMessage);
        //         return tmperrorMessage;
        //         // return resolve(tmperrorMessage);
        //         // toHtData.errorMessage = tmperrorMessage;
        //     })
        return await new Promise((resolve,reject)=>{
            setTimeout(function () {
                console.log("2秒后输出");
                resolve("2秒后输出");
            }, 2000);
        }) 

        // .then((valid) => {
        //     var tmperrorMessage = "";
        //     if (valid) {
        //         console.log('通过');
        //         tmperrorMessage = '';
        //     } else {
        //         tmperrorMessage = '校验不通过';
        //     }
        //     console.log("tmperrorMessage=====================",tmperrorMessage);
        //     return tmperrorMessage;
        //     // return resolve(tmperrorMessage);
        //     // toHtData.errorMessage = tmperrorMessage;
        // })
        // console.log("v==========",v);
    },

    /**
     * 验证某个指定字段的规则
     * @param {String} param 字段名
     * @param {Object} rules 规则
     * @param {Object} data 需要验证的数据对象
     */
    checkParamZdy: function (value, rules, messages) {
        // 缓存字段对应的值
        var errorMessage = "";
        if (value !== undefined) {
            // 遍历某个指定字段的所有规则，依次验证规则，否则缓存错误信息
            for (let method in rules) {

                // 判断验证方法是否存在
                if (this.isValidMethod(method)) {

                // 缓存规则的属性及值
                const rule = {
                    method: method,
                    parameters: rules[method]
                }
                var result = true;
                // 调用验证方法
                if (typeof (value) == "object") {
                    for (var k = 0; k < value.length; k++) {
                    if (result) {
                        result = this.methods[method](value[k], rule.parameters);
                    }
                    }
                } else {
                    result = this.methods[method](value, rule.parameters)
                }

                // 若result返回值为dependency-mismatch，则说明该字段的值为空或非必填字段
                if (result === 'dependency-mismatch') {
                    continue
                }
                if (!result) {
                    errorMessage = messages[method];
                }
                
                }
            }
        }
        return errorMessage;
    },

    /**
     * 根据 字段下标 获取字段对应的前一个的数据Index prevDataIndex
     */
    getPrevDataIndex: function (strIndex) {
        var tmpDataIndexArr = strIndex.split("-");
        var prevDateIndex = tmpDataIndexArr[tmpDataIndexArr.length - 1];
        return prevDateIndex;
    },

    /**
     * 进行后台的 数据保存
     */
    saveAddOrUpdate: function (that, callBack) {
        var pageUtils = this;
        // 判断是否需要进行异步校验
        var toHtData = {};
        //循环字段 进行
        var pageSetInfo = that.pageSetInfo;
        var fieldSet = pageSetInfo.fieldSet;
        var asyncNum = 0;
        var trueAsyncNum = 0;
        for (var i = 0; i < fieldSet.length; i++) {
            var element = fieldSet[i];
            if(element.asyncCheck) {
                asyncNum++;
                if(element.asyncCheckState) {
                    trueAsyncNum++;
                } else {
                    // 需要同步校验
                    pageUtils.checkPhoneYzm(that,element,1,callBack);
                    return;
                }
            }
        }
        if(asyncNum == trueAsyncNum) {
            //判断是否有 试题组件 如果有先进行试题的保存 再进行页面的保存
            console.log("that.$refs.questionInfo_ref==================================",that.$refs.questionInfo_ref);
            var ifBeginSave = false;
            if(that.$refs.questionInfo_ref) {
                that.$refs.questionInfo_ref[0].checkQuestion(function(questionInfo){
                    console.log("questionInfo==========------------------========================",questionInfo);
                    for (var i = 0; i < fieldSet.length; i++) {
                        var element = fieldSet[i];
                        if(element.zdyAliasName == "eqType") {
                            element.defaultCheckValue = questionInfo.eqType;
                        } else if(element.zdyAliasName == "eqWorkType") {
                            element.defaultCheckValue = questionInfo.eqWorkType;
                        } else if(element.zdyAliasName == "ZD_DO_WAY") {
                            element.defaultCheckValue = questionInfo.ZD_DO_WAY;
                        } else if(element.zdyAliasName == "mongoEqId") {
                            element.defaultValStr = questionInfo.mongoEqId;
                        } else if(element.zdyAliasName == "mongoId") {
                            element.defaultValStr = questionInfo.mongoId;
                        } else if(element.zdyAliasName == "eqContent") {
                            element.defaultValStr = questionInfo.eqContent;
                        } else if(element.zdyAliasName == "ifChild") {
                            element.defaultCheckValue = questionInfo.ifChild;
                        } else if(element.zdyAliasName == "childIdConcat") {
                            element.defaultValStr = questionInfo.childIdConcat;
                        } else if(element.zdyAliasName == "childScoreConcat") {
                            element.defaultValStr = questionInfo.childScoreConcat;
                        }
                    }
                    console.log("fieldSet==========------------------========================",fieldSet);
                    ifBeginSave = true;
                    pageUtils.saveAddOrUpdateToHt(that, callBack);    
                });
            } else {
                ifBeginSave = true;
            }
            if(ifBeginSave) {
                that.$refs['look_form_'+that.pageId].validate((valid) => {
                    var tmperrorMessage = "";
                    if (valid) {
                        pageUtils.saveAddOrUpdateToHt(that, callBack);
                    } else {
                        that.$message({
                            message: '校验不通过',
                            type: 'error',
                            offset: 50
                        });
                        return;
                    }
                })
            }
        }
    },
    /**
     * 
     * @param {后台保存数据} that 
     * @param {*} callBack 
     */
    saveAddOrUpdateToHt: function (that, callBack) {
        var toHtData = this.getToHtData(that, 0);
        console.log("toHtData==========保存前获取1===========",JSON.stringify(toHtData),toHtData.errorMessage);
        if (toHtData.errorMessage && toHtData.errorMessage != "") {
            that.$message({
                message: toHtData.errorMessage,
                type: 'error',
                offset: 50
            });
            return;
        }

        toHtData.isInterFace = 1;
        var url = "update_updateInfo.do";
        if(that.pageSetInfo.tableType == 10) {
            url = "mongoUpdate_updateInfo.do";
        }
        if (toHtData.pageType == 5) {
            url = "add_addInfo.do";
            if(that.pageSetInfo.tableType == 10) {
                url = "mongoAdd_addInfo.do";
            }
        } else if(toHtData.pageType == 8) {
            url = "batchUpdate_updateInfo.do";
        }
        var loading = that.$loading({
            lock: true,
            text: '保存中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
            url: url, //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
                loading.close();
                if (res.data != null) {
                    if(callBack) {
                        callBack(res.data, that)
                    }
                } else {
                    // 保存失败
                    that.$message({
                        message: res.data,
                        type: 'error'
                    });
                }
            },
            error:function(){
                loading.close();
                // 保存失败
                that.$message({
                    message: "服务器出现问题,请重试或者联系管理员",
                    type: 'error'
                });
            }
        })
    },

    /**
     * 是否是在微信客户端内部
     */
    isWeixinCient:function(){
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 是否是在微信客户端内部
     */
     getCientType:function(){
        var ua = navigator.userAgent.toLowerCase();
        var type = "";
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
            if(ua.match(/miniprogram/i)=="miniprogram") {
                type = 'miniprogram';
            } else {
                type = 'wechat';
            }
        } else {
            type = "";
        }
        return type;
    },

    /**
     * 打开支付页面
     * @param {*} orderJson 
     * @param {*} that 
     */
    toApply:function(orderJson, that){
        var pageUtils = this;
        if(orderJson.PAY_PLAT > 0) {
            //调用后台下单接口
            pageUtils.toKWPcOrH5Apply(orderJson,that);
        } else {
            if(pageUtils.isWeixinCient()) {
                // 判断 微信支付 还是支付宝支付
                pageUtils.toWxApply(orderJson, that);
            } else {
                // 打开微信和支付宝的选择页面
                that.$confirm("选择支付方式", '提示', {
                    confirmButtonText: '支付宝支付',
                    cancelButtonText: '微信支付',
                    distinguishCancelAndClose: true,
                    customClass:'comfirm_zdy',
                    type: 'warning'
                }).then(() => {
                    pageUtils.toZfbApply(orderJson, that);
                }).catch((error) => {
                    if(error == "cancel") {
                        pageUtils.toWxApply(orderJson, that);
                    }
                });
            }
        }
    },
    toKWPcOrH5Apply: function (orderJson, that) {
        var pageUtil = this;
        var loading = that.$loading({
            lock: true,
            text: '调起支付中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        //订单ID
        var orderId = orderJson.ORDER_ID;
        var toWxOrder = {};
        
        //订单Id
        toWxOrder.orderId = orderId;
        //公众号openID
        //openid
        toWxOrder.openid = localStorage.openId;
        //标价金额
        toWxOrder.total_fee = (orderJson.ORDER_MONEY * 100).toFixed(0); //1;
        //支付平台
        toWxOrder.payPlat = orderJson.PAY_PLAT;
        toWxOrder.payWay = orderJson.PAY_WAY;
        //调用微信下单
        utils.request(that,{
            url: "wx_kwPayAddOrder.do",
            data: toWxOrder,
            success: function (res) {
                loading.close();
                var applyUrl = res.data;
                var errerInfo = "";
                if(orderJson.PAY_WAY == 3) {
                    //pos刷卡支付，等待pos刷卡结果
                    that.wxPayCodeDialogJson = {
                        flag : true,
                        img_src:JSON.stringify(res.data),
                        total_fee:toWxOrder.total_fee,
                        PAY_WAY:orderJson.PAY_WAY
                    }
                } else {
                    if(orderJson.PAY_PLAT == 2) {
                        if (res.data.status == "succeeded") {
                            if(orderJson.PAY_WAY == 2) {
                                // PC支付 打开支付二维码
                                that.wxPayCodeDialogJson = {
                                    flag : true,
                                    img_src:res.data.expend.qrcode_url,
                                    total_fee:toWxOrder.total_fee,
                                    PAY_WAY:orderJson.PAY_WAY
                                }
                            } else if(orderJson.PAY_WAY == 1) {
                                // 微信内支付
                                // window.location.href=res.data.content;
                                console.log("res.data===========================",res.data);
                                var payment = JSON.parse(res.data.expend.pay_info);
                                // 微信内支付
                                pageUtil.weixinPay(that,payment);
                            }
                        } else {
                            errerInfo = "商户支付渠道升级中,带来不便请谅解！";
                        }
                    } else {
                        if (res.data.respCode == "0000") {
                            if(orderJson.PAY_WAY == 2) {
                                // PC支付 打开支付二维码
                                that.wxPayCodeDialogJson = {
                                    flag : true,
                                    img_src:res.data.content,
                                    total_fee:toWxOrder.total_fee,
                                    PAY_WAY:orderJson.PAY_WAY
                                }
                            } else if(orderJson.PAY_WAY == 1) {
                                // 微信内支付
                                window.location.href=res.data.content;
                            }
                        } else {
                            errerInfo = "商户支付渠道升级中,带来不便请谅解！";
                        }
                    }
                }
                if(errerInfo != "") {that.$message({
                        showClose: true,
                        message: errerInfo,
                        offset:50,
                        type: 'error'
                    });
                }
            }
        })
    },
    /**
     * 去微信支付 H5支付
     */
    toWxApply: function (orderJson, that) {
        var visitSource = utils.checkVisitSource();
        if(visitSource == 2) {
            // 调用PC端支付
            this.toWxPcOrH5Apply(orderJson, that, 2);
        } else {
            // 判断是否是 微信内浏览器 
            if(this.isWeixinCient()) {
                // 判断是否有 openId 如果有 直接进行支付 如果没有 进行微信授权 获取CODE然后再获取openId
                var openId = localStorage.openId;
                if(utils.isNotNull(openId)) {
                    this.toWxPcOrH5Apply(orderJson, that, 0);
                } else {
                    // 获取 code授权 
                    utils.getWxCode(orderJson, that);
                }
            } else {
                this.toWxPcOrH5Apply(orderJson, that, 1);
            }
        }
    },

    /**
     * 去微信支付 H5支付
     */
    toWxPcOrH5Apply: function (orderJson, that, flag) {
        var pageUtil = this;
        var loading = that.$loading({
            lock: true,
            text: '调起支付中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        //订单ID
        var orderId = orderJson.ORDER_ID;
        var toWxOrder = {};
        
        //订单Id
        toWxOrder.orderId = orderId;
        //附加数据  
        toWxOrder.attach = orderId;
        //商品描述
        toWxOrder.body = "可为商城系统-支付订单";
        //设备号 device_info  店铺id
        toWxOrder.device_info = '001';
        //商户号
        toWxOrder.mch_id = that.GLOBAL.mch_id[0];
        //商户平台的支付秘钥
        toWxOrder.key = that.GLOBAL.payKey[0];
        //公众号openID
        toWxOrder.appid = that.GLOBAL.app_id[0];
        // 判断商户支付账户类型 如果商品订单类型为社会实践订单
        if (orderJson.dataInfo && orderJson.dataInfo.PAY_KEY_TYPE > 0 && that.GLOBAL.mch_id.length >= orderJson.dataInfo.PAY_KEY_TYPE) {
            toWxOrder.mch_id = that.GLOBAL.mch_id[orderJson.dataInfo.PAY_KEY_TYPE-1];
            toWxOrder.key = that.GLOBAL.payKey[orderJson.dataInfo.PAY_KEY_TYPE-1];
            toWxOrder.appid = that.GLOBAL.app_id[orderJson.dataInfo.PAY_KEY_TYPE-1];
        }
        //openid
        if(flag == 0) {
            toWxOrder.openid = localStorage.openId;
        }
        //随机字符串 nonce_str 随机字符串
        toWxOrder.nonce_str = Math.random(9999999);
        //回调地址
        toWxOrder.notify_url = that.GLOBAL.baseURL + "wx_wxPaySuccess.do";//'http:/qq229338869.6655.la/edus/wx_wxPaySuccess.do';
        //商户订单号
        toWxOrder.out_trade_no = "bl_" + orderId;
        //签名类型
        toWxOrder.sign_type = "MD5";
        //终端IP
        toWxOrder.spbill_create_ip = '';
        //标价金额
        toWxOrder.total_fee = (orderJson.ORDER_MONEY * 100).toFixed(0); //1;
        //交易类型 
        toWxOrder.trade_type = "JSAPI";
        // H5支付
        toWxOrder.flag = flag;
        // console.info("toWxOrder========" + JSON.stringify(toWxOrder));
        //调用微信下单
        utils.request(that,{
            url: "wx_xcxAddWxOrder.do",
            data: toWxOrder,
            success: function (res) {
                loading.close();
                var applyUrl = res.data;
                if(flag == 0) {
                    // 微信内支付
                    pageUtil.weixinPay(that,res.data);
                } else if(flag == 1) {
                    // 拼接回调URL
                    var nowHref = "https://study.bailiedu.com/qcbl_edus_auto/return_url.jsp?out_trade_no="+"bl_" + orderId;
                    applyUrl+="&redirect_url="+encodeURI(nowHref);
                    // H5支付 直接跳转支付
                    window.location.href=applyUrl;
                } else if(flag == 2){
                    // PC支付 打开支付二维码
                    that.wxPayCodeDialogJson = {
                        flag : true,
                        img_src:applyUrl,
                        total_fee:toWxOrder.total_fee
                    }
                }
            }
        })
    },
    /**
     * 微信内发起支付
     */
    weixinPay: function(that,data) {
        var vm = this;
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady",vm.onBridgeReady(that,data),false);
            } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady",vm.onBridgeReady(that,data));
                document.attachEvent("onWeixinJSBridgeReady",vm.onBridgeReady(that,data));
            }
        } else {
            vm.onBridgeReady(that,data);
        }
    },
    /**
     * 支付成功回调
     */
    onBridgeReady: function(that,data){
        var vm = this;
        WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
                appId: data.appId, //公众号名称，由商户传入
                timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: data.nonceStr, //随机串
                package: data.package, //订单详情扩展字符串
                signType: data.signType, //微信签名方式：
                paySign: data.paySign, //微信签名
            },
            function(res) {
                if(res.err_msg == "get_brand_wcpay_request:ok"){
                    that.$message({
                        message: '支付成功，可以在已支付订单中进行查看',
                        type: 'success',
                    });
                    //支付成功之后，跳转到已支付页面
                    // that.orderPayNext();
                }else{
                    that.$message("支付失败！"+res.err_msg);
                }
            }
        );
    },
    /**
     * 去支付宝支付
     */
    toZfbApply: function (orderJson, that) {
        this.toHtAliAddOrder(orderJson, that);
    },

    /**
     * 进行支付宝后台下单  
     */
    toHtAliAddOrder:function(orderJson, that) {
        var loading = that.$loading({
            lock: true,
            text: '调起支付中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        var toHtData = {};

        //订单id:orderId
        var orderId = orderJson.ORDER_ID;
        toHtData.orderId = orderId;
        //订单金额:total_fee(orderJson.ORDER_MONEY * 100).toFixed(0)
        var total_fee = orderJson.ORDER_MONEY.toFixed(2);
        toHtData.total_fee = total_fee;

        var url = 'wx_aliPayCode.do';
        that.$axios.post(url,toHtData).then(res => {
            loading.close();
            const div = document.createElement('div');
            /* 此处form就是后台返回接收到的数据 */
            div.innerHTML = res.data;
            document.body.appendChild(div);
            document.getElementsByName("punchout_form")[0].submit();
        }).catch(error => {
            that.loading = false;
        });
    },

    /**
     * 打开联系客服页面
     */
    openCustomerPage: function (that,resJson){
        // 打开联系客服页面
        var customerInfo = that.$router.app.$children[0].customerInfo;
        var wx_url = resJson.wx_url ? resJson.wx_url : resJson.WX_URL;
        var wx_title_url = resJson.wx_title_url ? resJson.wx_title_url : resJson.WX_TITLE_URL;
        var wx_account = resJson.wx_account ? resJson.wx_account : resJson.WX_ACCOUNT;
        var wx_phone = resJson.wx_phone ? resJson.wx_phone : resJson.WX_PHONE;
        if (wx_url && wx_account && wx_url != "" && wx_account != "") {
            customerInfo.initContents = wx_account;
            if (wx_title_url) {
                customerInfo.initTitleUrl = wx_title_url.toLowerCase();
            }
            customerInfo.initCodeUrl = wx_url.toLowerCase();
            customerInfo.initPhone = wx_phone;
            
        } 
        customerInfo.showCustomerService = true;
        that.$router.app.$children[0].customerInfo = customerInfo;
    },

    /**
     * 去附件查看页面
     */
    toOpenFile:function (that,dataInfo, buttonSetOne, fieldAliasName) {
        //直接下载按钮
        var fileId = dataInfo[fieldAliasName];
        if (fileId == null || fileId.length == 0) {
            that.$message({
                message: '无相关文件',
                type: 'error'
            });
            return;
        }
        //判断是否是小程序打开
        var ifWxMiniProgram = false;
            wx.miniProgram.getEnv(function(res) {
                if(res.miniprogram) {
                    ifWxMiniProgram = true;
                }
            })
        if(!ifWxMiniProgram) {
            utils.openFile(that,fileId);
        } else {
            var url = '/pages/pageShow/file_download/file_download?fileSrc='+fileId;
            wx.miniProgram.navigateTo({
                url: url
            })
        }
    },

    /**
     * 去转发
     */
    toShareButtonInfo:function (that,dataInfo, buttonSetOne){
        var shareButtonInfo = that.$router.app.$children[0].shareButtonInfo;
        // 获取当前页面对象 list或者look页面
        shareButtonInfo.dataInfo = dataInfo;
        shareButtonInfo.buttonSet = buttonSetOne;
        shareButtonInfo.ifLoad = true;
        // that.$router.app.$children[0].shareButtonInfo = shareButtonInfo;
    },

    /**
     * 去图片查看 画布生成功能
     */
    toImageCanvas: function (that,dataInfo, buttonSetOne){
        // 获取当前页面对象 list或者look页面
        var imageCanvasInfo = that.$router.app.$children[0].imageCanvasInfo;
        imageCanvasInfo.dataInfo = dataInfo;
        imageCanvasInfo.buttonSet = buttonSetOne;
        imageCanvasInfo.ifLoad = true;
    },

    /**
     * 获取当前页面的路径地址 以及转发信息等
     */
    getShareRouteInfo:function (that,type){
        var pageRoute = window.location.href;
        var json = {};
        json.pageRoute = pageRoute;
        var userId = 0;
        var scene = "";
        // 登录人的信息
        if(utils.isNotNull(localStorage.loginInfo)) {
            var loginInfo = JSON.parse(localStorage.loginInfo);
            userId = loginInfo.USERID;
            scene = "S:" + userId;
        }
        if(utils.isNotNull(localStorage.openId) && type != 1) {
            scene += (scene!=""?",":"")+"sourceOpenId:"+localStorage.openId;
        }
        if (pageRoute.indexOf("look")>=0) {
            if(that.$router.app.$children[0]) {
                var nowPage = that.$router.app.$children[0].$children[0];
                if(nowPage) {
                    var pageInfo = nowPage.pageInfo;
                    // 如果是生成二维码 二维码的信息
                    scene += ",ID:" + pageInfo.mainId;
                    var codePageArr = that.GLOBAL.codePageArr;
                    var T = 0;
                    codePageArr.forEach((codePageOne, index) => {
                        if (codePageOne.pageId == pageInfo.pageId) {
                            T = index;
                        }
                    });
                    if (T>0) {
                     scene+=",T:"+T;
                    }
                    // 如果是转发 tableId pageId dataId
                    json.tableId = pageInfo.tableId;
                    json.pageId = pageInfo.pageId;
                    json.mainId = pageInfo.mainId;
                }
            }
        }
        json.scene = scene;
        return json;
    },

    /**
     * js自动获取弹出层的内容数据
     */
    autoGetDialogData:function (fieldSetIndexArr, that, chooseDataInfo) {
        var tableId = fieldSetIndexArr.dialogTableId;
        var pageId = fieldSetIndexArr.pageDialog;
        var chooseType = fieldSetIndexArr.chooseType;
        var dataMaxNum = fieldSetIndexArr.dataMaxNum;
        var urlType = 1;
        if (chooseType == 1) {
            urlType = 2;
        }
        var afterExeType = "";
        var addStyle = fieldSetIndexArr.addStyle;
        if(addStyle == 2 || chooseDataInfo) {
            afterExeType += "1";
        }
        if((chooseType == 2) && that.loadDicList) {
            afterExeType += "2";
        }
        this.autoGetDialogDataByInfo(that,fieldSetIndexArr,tableId,pageId,urlType,dataMaxNum,afterExeType,chooseDataInfo);
    },
    autoGetDialogDataByInfo:function(that,fieldSetIndexArr,tableId,pageId,urlType,dataMaxNum,afterExeType,chooseDataInfo){
        var pageUtils = this;
        var toHtData = {};
        //传递到后台用于搜索的参数
        //分页信息 
        toHtData.start = 0;
        toHtData.limit = 1000;
        // toHtData.ifGetAll=1;
        //tableId 表id
        toHtData.tableId = tableId;
        //pageId 页面id
        toHtData.pageId = pageId;
        toHtData.ifAjax = 1;
    
        var needFilter = fieldSetIndexArr.needFilter;
        var toHtFilter = this.getFilterData(needFilter, that, that.filedIndex);
    
        //判断是否需要把 弹出层的过滤条件 tmpJsonData 传递到后台
        var tmpJsonData = toHtFilter.tmpJsonData;
        if (tmpJsonData != null && tmpJsonData.length > 0) {
            var toHtArr = tmpJsonData.split("!");
            for (var i = 0; i < toHtArr.length; i++) {
                var oneArr = toHtArr[i].split("#");
                if (oneArr.length > 1) {
                    toHtData[oneArr[0]] = oneArr[1];
                }
            }
        }
        if(chooseDataInfo && chooseDataInfo.mainId > 0) {
            toHtData.orderDataId = chooseDataInfo.mainId;
        }
    
        var ajaxListUrl = 'model_ajaxList.do';
        if (urlType == 2) {
            ajaxListUrl = 'treeDialog_wxxcxAjaxList.do';
        }
        utils.request(that, {
            url: ajaxListUrl, //读取列表数据的接口
            data: toHtData,
            success: function (res) {
                var pageDataInfo = res.data.rows;
                if(afterExeType.indexOf("1")>=0 && pageDataInfo && pageDataInfo.length > 0) {
                    if(dataMaxNum == 0) {
                        dataMaxNum = pageDataInfo.length;
                    }
                    var detailValue = [];
                    var checkDataInfo = [];
                    for(var tmpI=0;tmpI<dataMaxNum;tmpI++) {
                        checkDataInfo.push(pageDataInfo[tmpI]);
                        detailValue.push(tmpI);
                    }
                    fieldSetIndexArr.defaultCheckValueIndex = 0;
                    fieldSetIndexArr.defaultCheckIndexArr = detailValue;
                    var detail = {};
                    detail.checkDataInfo = checkDataInfo;
                    detail.fieldOne = fieldSetIndexArr;
                    that.dialogClickCallBack(detail);
                } 
                if(afterExeType.indexOf("2")>=0) {
                    console.log("pageDataInfo=====================",pageDataInfo);
                    that.loadDicList(that, pageDataInfo, chooseDataInfo);
                } 
                if(afterExeType.indexOf("3")>=0) {
                    pageUtils.searchSetOneLoadDicList(fieldSetIndexArr,pageDataInfo);
                }
            }
        })
    },
    /**
     * 弹出层获取前置的过滤条件信息
     */
    getFilterData:function (needFilter, that, tmpIndex) {
        var date = {
            "tmpJsonData": "",
            "noInfoPrompt": ""
        };
        try{
            var kw_look = that.getParentKwLook();//this.getNowKwLook(that);
            if(needFilter != null && needFilter.length > 0 && kw_look) {
                if (kw_look) {
                    console.log("进入了getFilterData==========",needFilter, tmpIndex);
                    var pageSetInfo = kw_look.pageSetInfo;
                    var tmpArr = tmpIndex.split("-");
                    var nowDataId = tmpArr[tmpArr.length - 1];
                    if (nowDataId == null || nowDataId == "") {
                        nowDataId = 0;
                    }
                    //
                    var tmpJsonData = "";
                    var noInfoPrompt = "";
                    var needFilterArr = needFilter.split(",");
        
                    var fieldSet = pageSetInfo.fieldSet;
                    var fieldSetIndexArr = utils.getFieldSetByIndex(fieldSet, tmpIndex);
                    var hideFieldSet = pageSetInfo.hideFieldSet;
                    for (var i = 0; i < needFilterArr.length; i++) {
                        if (needFilterArr[i].indexOf("SESSION") == -1) {
                            var tmpOneArr = needFilterArr[i].split(":");
                            var tmpId = null;
                            var tmpFieldCnName = "";
                            if (tmpOneArr.length > 1) {
                                //判断是否是页面隐藏主键(关联添加的主键)
                                if (tmpId == null) {
                    
                                }
                                //判断是否是子集页面中的内容 根据index进行获取判断
                                if (tmpId == null) {
                    
                                }
                                if (tmpId == null) {
                                    var map = this.getFilterDataChild(tmpOneArr, fieldSet, nowDataId, tmpIndex, -1);
                                    tmpId = map.tmpId;
                                    tmpFieldCnName = map.tmpFieldCnName;
                                }
                    
                    
                                if ((tmpId == null || tmpId == undefined) && fieldSetIndexArr) {
                                    tmpId = fieldSetIndexArr["filter_" + tmpOneArr[1]];
                                }
                                
                                if ((tmpId == null || tmpId == undefined) && fieldSetIndexArr) {
                                    tmpId = fieldSetIndexArr.defaultIdStr;
                                }
                                //如果没有找到对应的过滤条件，就找对应的列表数据主键
                                if (tmpId == null || tmpId == undefined) {
                                    if(that.pageSetInfo && that.pageSetInfo.defaultIdStr > 0) {
                                        tmpId = that.pageSetInfo.defaultIdStr;
                                    } else {
                                        tmpId = kw_look.mainId;
                                    }
                                }
                                console.log("tmpId=====================",tmpId,(tmpId != undefined),(tmpId != 'undefined'),((tmpId+'') != ''),(tmpId != null && tmpId != undefined && tmpId != 'undefined' && tmpId != ''));
                                if (tmpId != null && tmpId != undefined && tmpId != 'undefined' && (tmpId+'') != '') {
                                    tmpJsonData += "!" + tmpOneArr[0] + "#" + tmpId;
                                } else if (tmpFieldCnName != undefined && tmpFieldCnName.length > 0) {
                                    noInfoPrompt +=  (noInfoPrompt!=""?"!":"")+ "必须先填写:" + tmpFieldCnName;
                                }
                            }
                        }
                    }
                    
                    date.tmpJsonData = tmpJsonData;
                    date.noInfoPrompt = noInfoPrompt;
                }
                //把查看页面的mainId作为参数默认传递到弹出层的后台去
            }
            if(kw_look) {
                date.tmpJsonData += "!mainId#" + kw_look.mainId;
            }
        } catch (error) {
            console.log(error);
        }
        return date;
    },
  
    getFilterDataChild:function (tmpOneArr, fieldSet, nowDataId, tmpIndex, j_index) {
        var tmpId = null;
        var tmpFieldCnName = "";
        var map = {};
        //循环页面的字段信息
        for (var j = 0; j < fieldSet.length; j++) {
            if (fieldSet[j].inputFName.endsWith("_" + tmpOneArr[1]) && (nowDataId == j_index || j_index == -1)) {
                
                if (tmpIndex.indexOf((fieldSet[j].prevFieldIndex + ":" + fieldSet[j].nowFieldIndex)) == 0) {
                    //if (fieldSet[j].defaultCheckValue != null && fieldSet[j].defaultCheckValue.split(",").length > nowDataId) {
                    tmpId = fieldSet[j].defaultCheckValue.split(",")[nowDataId];
                    //}
                } else {
        
                    tmpId = fieldSet[j].defaultCheckValue;
                }
                // if (fieldSet[j].dialogTableType == 3 && (tmpId != null && tmpId.length > 0)) {
                //     tmpId += ",1";
                // }
                tmpFieldCnName = fieldSet[j].fieldCnName;
                if (!tmpId) {
                    tmpId = fieldSet[j].defaultValStr;
                }
                console.log("tmpId进入了--------------",tmpId);
                if(!tmpId && tmpId != 0) {
                    tmpId = "";
                }
                map.tmpId = tmpId;
                map.tmpFieldCnName = tmpFieldCnName;
                console.log("进入了--------------",map,fieldSet[j]);
                return map;
            } else {
                //如果有子页面的字段信息 也进行循环  先不循环
                //
                var childPageJsonArr = fieldSet[j].childPageJsonArr;
                if(tmpIndex.startsWith(fieldSet[j].prevFieldIndex)) {
                    if (childPageJsonArr != null && childPageJsonArr.length > 0) {
                        for (let j_index = 0; j_index < childPageJsonArr.length; j_index++) {
                            const childPageDataOne = childPageJsonArr[j_index];
                            var childFieldSet = childPageDataOne.fieldSet;
                            map = this.getFilterDataChild(tmpOneArr, childFieldSet, nowDataId, tmpIndex, j_index);
                            if (map.tmpId != null) {
                                return map;
                            }
                        }
                    }
                }
            }
        }
        return map;
    },

    /**
     * 子表格数据的初始化
     * 弹出层选中之后回调进行赋值
     */
    confirmDialogCallBack: function (that, fieldSetIndexArr, callBackIndex, nameFlag) {
        //获取前一个的dataIndex
        var prevDateIndex = this.getPrevDataIndex(callBackIndex);
        var checkedPageData = fieldSetIndexArr.defaultCheckDataList;
        //进行子表格数据的绑定
        var childFieldSetBase = fieldSetIndexArr.childFieldSet;
        //dialogIdName
        var dialogIdName = fieldSetIndexArr.dialogIdName;
        var updateIdName = fieldSetIndexArr.updateIdName;
        var relationTableId = fieldSetIndexArr.relationTableId;
        var childDialogTableId = fieldSetIndexArr.dialogTableId;
        var tmpString1 = JSON.stringify(childFieldSetBase);
        //if (fieldSetIndexArr.childPageJsonArr == null) {
        //获取之前的子表格的值
        var prevChildPageJsonArr = fieldSetIndexArr.childPageJsonArr;
        fieldSetIndexArr.childPageJsonArr = [];
        if (childFieldSetBase.length == 1) {
            fieldSetIndexArr.childHide = true;
        }
        //}
        console.log("checkedPageData============================",checkedPageData);
        console.log("childFieldSetBase============================",childFieldSetBase);
        //循环选中的数据列表信息 进行子表格的加载
        for (var i = 0; i < checkedPageData.length; i++) {
            var childFieldSet = JSON.parse(tmpString1);
            //循环子表格的字段信息 赋值prevFieldIndex
            var childMaxCol = 0;
            var dialogDataId = checkedPageData[i]["T_" + childDialogTableId + "_0"];
            //查找已填写数据中是否有此数据 如果有则进行填写数据的默认赋值
            var prevCheckedPageDataOne = null;
            if(prevChildPageJsonArr && fieldSetIndexArr.addStyle != 3) {
                prevChildPageJsonArr.forEach((prevChildPageJsonOne, prevCheckindex) => {
                    if(prevChildPageJsonOne.defaultIdStr == dialogDataId) {
                        prevCheckedPageDataOne = prevChildPageJsonOne;
                    }
                });
            }
            if (childFieldSet.length > 1) {
                for (var j = 0; j < childFieldSet.length; j++) {
                    childFieldSet[j].prevFieldIndex = callBackIndex;
                    if(!childFieldSet[j].ifHide) {
                        childMaxCol++;
                    }
                    //判断子表格字段是否是页面弹出层中的值
                    var dialogFieldAliasName = childFieldSet[j].dialogFieldAliasName;
                    if(nameFlag) {
                        if(dialogFieldAliasName==null || dialogFieldAliasName == undefined || dialogFieldAliasName == "") {
                            dialogFieldAliasName = childFieldSet[j].fieldAliasName
                        }
                    }
                    //如果当前选中值 不为空 并且 弹出层中的值不为空则 设置默认值
                    if (checkedPageData[i][dialogFieldAliasName] != null) {
                        childFieldSet[j].defaultValStr = checkedPageData[i][dialogFieldAliasName];
                        if(childFieldSet[j].fieldType>=4 && (childFieldSet[j].defaultValStr && childFieldSet[j].defaultValStr != "")) {
                            childFieldSet[j].defaultCheckValue = childFieldSet[j].defaultValStr;
                        }
                    } else {
                        if(childFieldSet[j].fieldType>4 && (childFieldSet[j].defaultValStr && childFieldSet[j].defaultValStr != "")) {
                            childFieldSet[j].defaultCheckValue = childFieldSet[j].defaultValStr;
                        }
                    }
                    // console.log("childFieldSet[j]====================================",childFieldSet[j].defaultCheckValue,childFieldSet[j].defaultValStr);
                    
                    // console.log("childFieldSet[j]====================================",childFieldSet[j]);
                    //选中前就已经选中 并且当前字段是需要填写字段 则进行赋值
                    if(prevCheckedPageDataOne && childFieldSet[j].ifUpdate == 1) {
                        childFieldSet[j].defaultValStr = prevCheckedPageDataOne.fieldSet[j].defaultValStr;
                        childFieldSet[j].defaultCheckValue = prevCheckedPageDataOne.fieldSet[j].defaultCheckValue;
                    }

                    this.loadFieldRulesByField(childFieldSet[j]);

                    //判断是否是弹出层回填字段 非当前表字段如果是把是否强制默认值设置为是
                    if(childFieldSet[j].tableId != relationTableId) {
                        childFieldSet[j].ifShowDefVal = 1;
                    }
                }
            } else {
                childFieldSet = [];
            }
            // this.initToUpdateField(childFieldSet, checkedPageData[i], that, "", 0,that.pageSetInfo);
            this.initAddOrUpdateDefaultValue(childFieldSet,that);
            var oneChildJson = {
                "fieldSet": childFieldSet,
                "defaultIdStr": dialogDataId,
                "nowDataIndex": fieldSetIndexArr.childPageJsonArr.length,
                "prevDateIndex": prevDateIndex,
                "dialogIdName": dialogIdName,
                "updateIdName": updateIdName,
                "updateDataId": checkedPageData[i]["T_" + relationTableId + "_0"],
                "dataInfo": checkedPageData[i],
                "maxRow":0,
                "maxCol":childMaxCol>1?childMaxCol-1:childMaxCol,
                "showHideJsList":that.pageSetInfo?that.pageSetInfo.showHideJsList:'',
                "name_indexMap":that.pageSetInfo?that.pageSetInfo.name_indexMap:null
            }
            fieldSetIndexArr.childPageJsonArr.push(oneChildJson);
            fieldSetIndexArr.childMaxCol = childMaxCol>1?childMaxCol-1:childMaxCol;
        }
        // if(typeof(that["zdyValueChange_"+fieldSetIndexArr.fieldId]) == "function") {
        //     that["zdyValueChange_"+fieldSetIndexArr.fieldId](that,utils,pageUtils);
        // }
    },
    /**
     * 发送短信验证码
     * @param {} that 
     * @param {*} fieldOne 
     */
    sendMsgYzm:function(that, fieldOne){
        var telPhone = fieldOne.defaultValStr;
        if (fieldOne.rules && !fieldOne.ifHide) {
            var errorMessage = that.WxValidate.checkParamZdy(telPhone, fieldOne.rules, fieldOne.messages);
            if (errorMessage == null || errorMessage=="") {
                that.yzmFlag = true;
                var toHtData = {};
                toHtData.telPhone = telPhone;
                toHtData.sentType = 1;
                var url = 'login_registerPhoneMsg.do';
                utils.request(that,{
                    url: url, //读取列表数据的接口
                    data: toHtData,
                    success: function (res) {
                        var registerId = res.data;
                        if(registerId > 0) {
                            that.registerId = registerId;
                            that.registerPhone = telPhone;
                            that.auth_time = 60;
                            that.getAuthCode();
                            that.$message({
                                message: "验证码发送成功!",
                                type: 'success'
                            });
                        } else {
                            that.yzmFlag = false;
                            that.$message({
                                message: "验证码发送失败,请重试!",
                                type: 'error'
                            });
                        }
                    }
                })
            }
        }
    },
    /**
     * 检查短信验证码异步验证是否通过
     * @param {} that 
     * @param {*} fieldOne 
     * @param {*} callBack 
     */
    checkPhoneYzm(that,fieldOne,ifNext,prevCallBack){
        var pageUtils = this;
        var registerId = that.registerId;
        var registerPhone = fieldOne.defaultValStr;
        var code = that.yzmCode;
        if (!code || code.length != 6) {
            if(ifNext == 1) {
                that.$message({
                    message: '验证码未填写或者位数不够!',
                    type: 'error'
                });
            }
            return false;
        }
        if(registerId==0) {
            that.$message({
                message: '未发送短信验证码!',
                type: 'error'
            });
            return false;
        }
        var toHtData = {};
        toHtData.registerId = registerId;
        toHtData.loginName = registerPhone;
        toHtData.sjNum = code;
        var flag = false;
        var url = 'login_toCheckRegister.do';
        utils.request(that,{
            url: url, //读取列表数据的接口
            data: toHtData,
            success: function (res) {
                var checkState = res.data;
                if(checkState > 0) {
                    if(ifNext == 1) {
                        fieldOne.asyncCheckState = true;
                        pageUtils.saveAddOrUpdate(that,prevCallBack);
                    }
                } else {
                    that.$message({
                        message: '验证码错误!',
                        type: 'error'
                    });
                }
            }
        })
        
    },
    
    /**
     * 根据 字段下标 获取字段对应的前一个的数据Index prevDataIndex
     */
    getPrevDataIndex: function(strIndex) {
        var tmpDataIndexArr = strIndex.split("-");
        var prevDateIndex = tmpDataIndexArr[tmpDataIndexArr.length - 1];
        return prevDateIndex;
    },

    /**
     * 跳转到商城首页
     */
    toMailHome:function(that){
        var domain_name = localStorage.domain_name;
        var path = '/mailHome';
        if(utils.isNotNull(domain_name)) {
            path+="/"+domain_name;
        }
        var pushJson = { 
            path:path
        };
        if(that.pageInfo.initActiveName) {
            pushJson.query = {initActiveName:that.pageInfo.initActiveName}
        }
        var routePath = that.$route.path;
        if(routePath.indexOf("mailHome")>0) {
            that.$router.push(pushJson);
            window.location.reload();
        } else {
            that.$router.push(pushJson);
        }
    },

    /**
     * 跳转到扫码页面
     */
    toOpenScan:function(that,buttonSetOne,url,dataInfo){
        var tablePage = url.substring(7);
        if (tablePage && tablePage.indexOf(":") > 0) {
          var turnTableId = tablePage.split(":")[0];
          var startTurnPage = tablePage.split(":")[1];
          var mainId = 0;
          if (tablePage.split(":").length > 2) {
            if (dataInfo.MAIN_ID) {
              nowDataId = dataInfo.MAIN_ID;
            }
            if(tablePage.split(":")[2] > 0) {
              nowDataId = tablePage.split(":")[2];
            }
            mainId = nowDataId;
          } else {
            if (dataInfo.MAIN_ID) {
              mainId = dataInfo.MAIN_ID;
            } else {
              mainId = dataInfo.LMF_ID;
            }
          }
          var url = '/pages/pageShow/open_scan/open_scan?';
          url += "turnTableId=" + turnTableId;
          url += "&startTurnPage=" + startTurnPage;
          url += "&nextOperaType=" + buttonSetOne.nextOperaType;
          
          url += "&mainId=" + mainId;
          console.log()
          url += "&sessionId=" + localStorage.sessionId;
          wx.miniProgram.navigateTo({
              url:url
          })
        }
    },

    /**
     * 如果扫码进入页面 则进行扫码参数的逻辑处理
     */
    initScene: function (that, scene, pageInfo){
        var scene_id = decodeURIComponent(scene); //获取二维码的参数
        // console.info('scene_id : ' + scene_id)
    
        if (scene_id == 'undefined' || !scene_id || scene_id == null) {
            if (utils.isNotNull(localStorage.sceneJson)) {
                var sceneJson = JSON.parse(localStorage.sceneJson);
                var sourceOpenId = sceneJson.sourceOpenId;
                if (sourceOpenId) {
                var sceneJson = {
                    sourceOpenId: sourceOpenId
                }
                var scene = "sourceOpenId:" + sourceOpenId;
                localStorage.scene_id = scene;
                localStorage.sceneJson = JSON.stringify(sceneJson);
                } else {
                localStorage.scene_id = "";
                localStorage.sceneJson = "";
                }
            } else {
                localStorage.scene_id = "";
                localStorage.sceneJson = "";
            }
        } else {
            var newscene_id = "{\"" + scene_id.replace(/:/g, "\":\"").replace(/,/g, "\",\"") + "\"}";
            // console.info('scene_id 转换后: ' + newscene_id)
            var sceneJson = JSON.parse(newscene_id);
            if (sceneJson.ID > 0) {
                pageInfo.mainId = sceneJson.ID
            }
            if(sceneJson.TABLE_ID>0) {
                pageInfo.tableId = sceneJson.TABLE_ID;
                pageInfo.pageId = sceneJson.PAGE_ID;
            }
            // 把扫码信息 或者 转发信息 放置到app.globalData中
            localStorage.scene_id = scene_id;
            localStorage.sceneJson = JSON.stringify(sceneJson);
            that.scene_id = scene_id;
            that.sceneJson = sceneJson;
        }
    },

    /**
     * 跳转到列表页面
     */
    toNewListPage: function (that,json){
        var appPage = that.$router.app.$children[0];
        var nowPage = appPage.$refs.router_main;
        var kwParam = "";
        var listParam = that.GLOBAL.listParam;
        //判断当前是否过滤权限
        if(that.isLimitButton) {
            json.isLimitButton = that.isLimitButton
        }
        listParam.forEach(key => {
            kwParam+=(json[key]?json[key]:"")+"_";
        });
        // var jsonStr = JSON.stringify(json);
        kwParam = utils.kwBtoa(kwParam);
        
        
        console.log("kwParam================",kwParam);
        if(!nowPage.checkTabExists && json.openWay == 5) {
            json.openWay = 1;
        }
        //如果是从mailHome页面打开则记录当前的
        if(nowPage.activeName) {
            json.initActiveName = nowPage.activeName;
        }
        if(json.openWay == 5) {
            // 后台选项卡打开
            // 打开后台系统的选项卡
            json.menuId = "new_list_" + json.tableId + "_" + json.pageId + (json.mainId>0?"_" + json.mainId:0);
            json.url = "new_list?noHead=1&kw_param=" + kwParam;
            nowPage.checkTabExists(json);
        } else {
            // 判断是否是小程序内打开
            var ifWxMiniProgram = false;
            wx.miniProgram.getEnv(function(res) {
                if(res.miniprogram) {
                    var url = '/pages/pageShow/new_list/new_list?';
                    for (var key in json) {
                        url += "&" + key + "=" + json[key]
                    }
                    if (json.jumpWay == 1) {
                        wx.miniProgram.redirectTo({
                            url: url
                        })
                    } else {
                        wx.miniProgram.navigateTo({
                            url: url
                        })
                    }
                    ifWxMiniProgram = true;
                }
            })
            if(!ifWxMiniProgram) {
                var routePath = that.$route.path;
                if(routePath.indexOf("new_list")>0) {
                    routePath+="?kw_param="+kwParam;
                    for (var key in json) {
                        if(listParam.indexOf(key)==-1) {
                            routePath += "&" + key + "=" + json[key];
                        }
                    }
                }
                // 判断是否flutter中打开 如果是则 进行flutter新开窗口的方法调用
                var ifFlutter = false;
                try {
                    _flutterToOpenListPage.postMessage(kwParam);
                    ifFlutter = true;
                } catch (error) {
                    ifFlutter = false;
                } 
                if(!ifFlutter) {
                    if(routePath.indexOf("new_list")>0) {
                        that.$router.push({ 
                            path:routePath
                        });
                        window.location.reload();
                    } else {
                        var query = {
                            kw_param:kwParam
                        }
                        for (var key in json) {
                            if(listParam.indexOf(key)==-1) {
                                query[key] = json[key]
                            }
                        }
                        that.$router.push({ 
                            name: 'new_list', 
                            query: query
                        });
                    }
                }
            }
        }

        // var jsonStr = utils.kwBtoa(kwParam);
        // that.$router.push({ 
        //     name: 'route_middel', 
        //     query: {
        //         type:"new_list",
        //         kw_param:jsonStr
        //     }
        // });
    },
    
    /**
     * 跳转到查看页面
     */
    toNewLookPage: function (that,json) {
        // 判断是否在后台项目中 如果是在后台项目中新开一个大选项卡
        var appPage = that.$router.app.$children[0];
        var nowPage = appPage.$refs.router_main;
        var afterProgremFlag = false;
        if(nowPage.addTab || typeof(window.parent.openNewPage)=='function') {
            //判断是否是后台系统打开页面
            afterProgremFlag = true;
            if(!json.openWay) {
                json.openWay = 2;
            }
        } else if(appPage && appPage.openWay == 2) {
            afterProgremFlag = true;
            if(!json.openWay) {
                json.openWay = 2;
            }
        }
        // console.log("appPage============================",appPage,json);
        // console.log("nowPage============================",nowPage);
        //如果是从mailHome页面打开则记录当前的
        if(nowPage.activeName) {
            json.initActiveName = nowPage.activeName;
        }
        //判断当前是否过滤权限
        if(that.isLimitButton) {
            json.isLimitButton = that.isLimitButton
        }
        console.log("json=================================",json,appPage);
        if(json.openWay == 2) {
            var dialogInfo = that.dialogInfo;
            if(dialogInfo.ifLoad) {
                dialogInfo.ifLoad = false;
                that.$nextTick(function(){
                    dialogInfo.pageInfo = json;
                    dialogInfo.type = 11;
                    dialogInfo.ifLoad = true;
                    dialogInfo.sourceOpenThat = that;
                })
            } else {
                dialogInfo.pageInfo = json;
                dialogInfo.type = 11;
                dialogInfo.ifLoad = true;
                dialogInfo.sourceOpenThat = that;
            }
        } else {
            // 跳转页面 不是弹出层打开
            var kwParam = "";
            var lookParam = that.GLOBAL.lookParam;
            lookParam.forEach(key => {
                kwParam+=(json[key]?json[key]:"")+"_";
            });
            kwParam = utils.kwBtoa(kwParam);
            if(!nowPage.checkTabExists && json.openWay == 5) {
                json.openWay = 1;
            }
            if(json.openWay == 4){
                // 打开新浏览器页签页面
                let routeData = that.$router.resolve({
                    name: 'look',
                    query: {
                        kw_param:kwParam
                    }
                })
                window.open(routeData.href, '_blank')
            } else if(json.openWay == 5) {
                json.actionWay = 2;
                // 打开后台系统的选项卡
                json.menuId = "look_" + json.tableId + "_" + json.pageId + (json.mainId>0?"_" + json.mainId:0);
                json.url = "look?noHead=1&kw_param=" + kwParam;
                nowPage.checkTabExists(json);
            } else {
                // 判断是否是小程序内打开
                var ifWxMiniProgram = false;
                wx.miniProgram.getEnv(function(res) {
                    if(res.miniprogram) {
                        var url = '/pages/pageShow/look/look?';
                        for (var key in json) {
                            url += "&" + key + "=" + json[key]
                        }
                        if(json.jumpWay == 1) {
                            wx.miniProgram.redirectTo({
                                url: url
                            })
                        } else {
                            wx.miniProgram.navigateTo({
                                url: url
                            })
                        }
                        ifWxMiniProgram = true;
                    }
                })
                if(!ifWxMiniProgram) {
                    var routePath = that.$route.path;
                    if(routePath.indexOf("look")>0) {
                        routePath+="?kw_param="+kwParam;
                        for (var key in json) {
                            if(lookParam.indexOf(key)==-1) {
                                routePath += "&" + key + "=" + json[key];
                            }
                        }
                    }
                    // 判断是否flutter中打开 如果是则 进行flutter新开窗口的方法调用
                    var ifFlutter = false;
                    try {
                        _flutterToOpenLookPage.postMessage(kwParam);
                        ifFlutter = true;
                    } catch (error) {
                        ifFlutter = false;
                    } 
                    if(!ifFlutter) {
                        if(routePath.indexOf("look")>0) {
                            that.$router.push({ 
                                path:routePath
                            });
                            window.location.reload();
                        } else {
                            var query = {
                                kw_param:kwParam
                            }
                            for (var key in json) {
                                if(lookParam.indexOf(key)==-1) {
                                    query[key] = json[key]
                                }
                            }
                            that.$router.push({ 
                                name: 'look', 
                                query: query
                            });
                        }
                    }
                }
            }
        }
    },

    /**
     * 跳转到做试卷页面
     */
    toNewDoExamPaper: function (that,json) {
        // 跳转页面 不是弹出层打开
        var jsonStr = JSON.stringify(json);
        jsonStr = window.btoa(jsonStr);
        that.$router.push({ 
            name: "vueDoExamPaper", 
            query: {
                kw_param:jsonStr
            }
        });
    },

    /**
     * 返回前一页 判断是否是弹出层 如果是弹出层 关闭弹出层 如果是跳转页面 返回上一页
     */
    navigateBack:function(that){
        that.$emit("goBack");
    },
    
    /**
     * 获取当前页面中的kw_look组件 (最新的当前显示的)
     */
    getNowKwLook:function(that){
        var appPage = that.$router.app.$children[0];
        var kw_look = null;
        if(appPage.$refs.kw_look_dialog) {
            kw_look = typeof(appPage.$refs.kw_look_dialog.length)=='number'?appPage.$refs.kw_look_dialog[0]:appPage.$refs.kw_look_dialog;
        } else {
            var nowPage = appPage.$children[0];
            kw_look = typeof(nowPage.$refs.kw_look.length)=='number'?nowPage.$refs.kw_look[0]:nowPage.$refs.kw_look;
        }
        return kw_look;
    },

    /**
     * 获取当前页面中的kw_look组件 
     */
    getPageKwLook:function(that){
        var appPage = that.$router.app.$children[0];
        var kw_look = null;
        var nowPage = appPage.$refs.router_main;
        kw_look = typeof(nowPage.$refs.kw_look.length)=='number'?nowPage.$refs.kw_look[0]:nowPage.$refs.kw_look;
        return kw_look;
    },
    /**
     * 获取虚拟登录账户主键
     */
    getShamOpenId:function(){
        var domain_name = localStorage.domain_name;
        var shamOpenId = localStorage.shamOpenId;
        if(utils.isNotNull(domain_name)) {
            shamOpenId = localStorage[domain_name+"_shamOpenId"];
        }
        return shamOpenId;
    },
    /**
     * 设置虚拟登录账户主键
     */
    setShamOpenId:function(shamOpenId){
        var domain_name = localStorage.domain_name;
        if(utils.isNotNull(domain_name)) {
            localStorage[domain_name+"_shamOpenId"] = shamOpenId;
        } else {
            localStorage.shamOpenId = shamOpenId;
        }
        try {
            _flutterSetShamOpenId.postMessage(shamOpenId);
        } catch (error) {
        } 
    },
    /**
     * 获取首页设置的菜单按钮
     */
    getHomeMenuList:function(sourceType){
        var domain_name = localStorage.domain_name;
        var homeMenuList = localStorage.homeMenuList;
        if(utils.isNotNull(domain_name)) {
            homeMenuList = localStorage[domain_name+"_homeMenuList"];
        }
        if(homeMenuList) {
            var tmpHomeMenuList = JSON.parse(homeMenuList);
            var finalHomeMenuList = [];
            var visitSource = utils.checkVisitSource();
            var login_proId = "";
            if(utils.isNotNull(localStorage.loginInfo)) {
                var loginInfo = JSON.parse(localStorage.loginInfo);
                login_proId = loginInfo.login_proId;
            }
            console.log("login_proId====================11111111111111====",login_proId);
            tmpHomeMenuList.forEach((homeMenuOne, index) => {
                if(login_proId == "" || homeMenuOne.proId == login_proId || !homeMenuOne.proId || homeMenuOne.proId=="") {
                    console.log("login_proId====================11111111111111====",login_proId,homeMenuOne.proId);
                    if(homeMenuOne.ZD_IF_PHONE) {
                        if(visitSource == 3) {
                            if(sourceType == "mainPage" && homeMenuOne.ZD_IF_PHONE == 3) {
                                finalHomeMenuList.push(homeMenuOne);
                            } else if(!sourceType && homeMenuOne.ZD_IF_PHONE == 1) {
                                finalHomeMenuList.push(homeMenuOne);
                            }
                        } else if(visitSource == 2 && homeMenuOne.ZD_IF_PHONE == 2) {
                            finalHomeMenuList.push(homeMenuOne);
                        }
                    } else {
                        finalHomeMenuList.push(homeMenuOne);
                    }
                    console.log("finalHomeMenuList====================11111111111111====",finalHomeMenuList);
                }
            })
            return JSON.stringify(finalHomeMenuList);
        } else {
            return homeMenuList;
        }
    },
    /**
     * 设置首页设置的菜单按钮
     */
    setHomeMenuList:function(homeMenuList){
        var domain_name = localStorage.domain_name;
        //判断homeMenuList是否有父子级 如果有则进行父子级的重组
        console.log("setHomeMenuList====================",homeMenuList);
        var homeBarType = 0;
        if(homeMenuList) {
            var tmpHomeMenuList = JSON.parse(homeMenuList);
            var finalHomeMenuList = [];
            tmpHomeMenuList.forEach((homeMenuOne, index) => {
                homeMenuOne.barName = homeMenuOne.BAR_NAME;
                homeMenuOne.barIcon = homeMenuOne.BAR_ICON;
                homeMenuOne.barCurrentIcon = homeMenuOne.BAR_CURRENT_ICON;
                homeMenuOne.barKey = homeMenuOne.BAR_KEY;
                homeMenuOne.mainIdType = homeMenuOne.MAIN_ID_TYPE;
                homeMenuOne.ifShow = homeMenuOne.ZD_IF_SHOW;
                homeMenuOne.ifLogin = homeMenuOne.ZD_IF_LOGIN;
                homeMenuOne.pageId = homeMenuOne.PAGE_ID;
                homeMenuOne.tableId = homeMenuOne.TABLE_ID;
                homeMenuOne.listTableId = homeMenuOne.LIST_TABLE_ID;
                homeMenuOne.proId = homeMenuOne.PRO_ID;
                if(!homeMenuOne.PARENT_ID || homeMenuOne.PARENT_ID == 0) {
                    finalHomeMenuList.push(homeMenuOne);
                } else {
                    if(homeMenuOne.ZD_IF_PHONE != 2) {
                        homeBarType = 1;
                    }
                    finalHomeMenuList.forEach((finalMenuOne, finalIndex) => {
                        if(finalMenuOne.C_H_M_ID == homeMenuOne.PARENT_ID) {
                            if(!finalMenuOne.childMenu) {
                                finalMenuOne.childMenu = [];
                            }
                            finalMenuOne.childMenu.push(homeMenuOne);
                        }
                    })
                }
            });
            console.log("finalHomeMenuList===================",finalHomeMenuList);
            homeMenuList = JSON.stringify(finalHomeMenuList);
        }
        if(utils.isNotNull(domain_name)) {
            localStorage[domain_name+"_homeMenuList"] = homeMenuList;
            localStorage[domain_name+"_homeBarType"] = homeBarType;
        } else {
            localStorage.homeMenuList = homeMenuList;
            localStorage[domain_name+"homeBarType"] = homeBarType;
        }
        try {
            _flutterSetHomeMenuList.postMessage(homeMenuList);
        } catch (error) {
        } 
    },
    getHomeBarType:function(){
        var domain_name = localStorage.domain_name;
        var homeBarType = localStorage.homeBarType;
        if(utils.isNotNull(domain_name)) {
            homeBarType = localStorage[domain_name+"_homeBarType"];
        }
        return homeBarType;
    },
    /**
     * 设置全局参数
     * @param {} key 
     * @param {*} value 
     */
    setSessionParam:function(key,value){
        var domain_name = localStorage.domain_name;
        if(utils.isNotNull(domain_name)) {
            localStorage[domain_name+"_"+key] = value;
        } else {
            localStorage[key] = value;
        }
    },
    /**
     * 读取全局参数
     */
    getSessionParam:function(key){
        var domain_name = localStorage.domain_name;
        var value = localStorage[key];
        if(utils.isNotNull(domain_name)) {
            value = localStorage[domain_name+"_"+key];
        }
        return value;
    },
    setCookie: function (cname, cvalue, exdays) {
        if(exdays) {
            let d = new Date()
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
            let expires = 'expires=' + d.toUTCString()
            document.cookie = cname + '=' + cvalue + '; ' + expires
        } else {
            document.cookie = cname + '=' + cvalue + ';'
        }
    },
    getCookie: function (cname) {
        let name = cname + '='
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
            return c.substring(name.length, c.length)
        }
        }
        return ''
    },
    clearCookie: function (cname) {
        this.setCookie(cname, '', -1)
    },
    /**
     * 下载文件
     */
    downLoadFile: function(url,toHtData,fileName,that){
        var ifFlutter = false;
        // try {
        //     if(_flutterDownloadFile) {
        //         _flutterDownloadFile.postMessage(url + "_kw_" + fileName);
        //         ifFlutter = true;
        //     }
        // } catch (error) {
        // }
        if(!ifFlutter) {
            // fetch(url).then(
            that.$axios({
                // 用axios发送post请求
                method: "post",
                url:url, // 请求地址
                data: toHtData, // 参数
                responseType: "blob", // 表明返回服务器返回的数据类型
            }).then(
                res => {
                    // 处理返回的文件流
                    const content = res.data;
                    const blob = new Blob([content],{type:"application/vnd.ms-excel;charset=utf-8"});
                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        const elink = document.createElement("a");
                        // if(!fileName) {
                        //     fileName = "下载文件.kw"
                        // }
                        elink.download = fileName;
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    } 
                    else {
                      // IE10+下载
                      navigator.msSaveBlob(blob, fileName);
                    }
                }
            )
        }
        // that.$axios.post(url).then(
        //     res => res.data.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        //         const a = document.createElement('a')
        //         a.href = URL.createObjectURL(blob)
        //         console.log(a.href)
        //         if(fileName) {
        //             a.download = fileName  // 下载文件的名字
        //         }
        //         // document.body.appendChild(a)
        //         a.click()
        //     }
        // )
    },
    /**
     * json转成get参数
     */
    jsonToParamStr:function(toHtJson){
        var params = Object.keys(toHtJson).map(function (key) {
            return key + "=" + encodeURIComponent(toHtJson[key]); 
        }).join("&");
        return params;
    },
    /**
     * 保存 审核数据
     */
    saveCheckFlowData:function(that,callBack){
        var mainTableId = that.tableId;
        var rbMainId = that.mainId;
        var CHECK_STATE = -1;
        var CHECK_REMARK = "";
        var CHECK_FLOOR = 0;
        var mainDataId = 0;
        var checkFlowFloorList = that.checkFlowFloorList;
        checkFlowFloorList.forEach(checkFlowFloorOne => {
            if(checkFlowFloorOne.ifSave == true) {
                CHECK_STATE= checkFlowFloorOne.CHECK_STATE?checkFlowFloorOne.CHECK_STATE:0;
                CHECK_REMARK= checkFlowFloorOne.REMARK?checkFlowFloorOne.REMARK:'';
                CHECK_FLOOR= checkFlowFloorOne.CHECK_FLOOR;
                mainDataId = checkFlowFloorOne.NODE_ID;
            }
        });
        if(CHECK_STATE > 0) {
            var toHtData = {};
            //保存 审核
            toHtData.mainTableId = mainTableId;
            toHtData.rbMainId = rbMainId;
            toHtData.CHECK_STATE = CHECK_STATE;
            toHtData.CHECK_REMARK = CHECK_REMARK;
            toHtData.CHECK_FLOOR = CHECK_FLOOR;
            toHtData.mainDataId = mainDataId;
            var url = "model_updateCheckState.do";
            var loading = that.$loading({
                lock: true,
                text: '保存中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
            utils.request(that,{
                url: url, //仅为示例，并非真实的接口地址
                data: toHtData,
                success: function (res) {
                    loading.close();
                    // 保存失败
                    that.$message({
                        message: "审核成功",
                        type: 'success'
                    });
                    if(callBack) {
                        callBack(that.mainId, that);
                    }
                }
            })
            return false;
        } else if(CHECK_STATE == 0) {
            that.$message({
                message: '没有选择审批状态!',
                type: 'error'
            });
            return false;
        } else {
            //不是审核人或者没有到达您的审批层级  不可以进行审批
            // that.$message({
            //     message: '不是审核人或者没有到达您的审批层级!',
            //     type: 'error'
            // });
            return true;
        }
    },
    /**
     * 打开文件预览页面
     * @param {} that 
     * @param {*} file 
     * @param {*} fieldone 
     */
    toPreviewFile:function(that,file,fieldone){
        var pageUtils = this;
        if(that.filePreviewInfo.ifLoad) {
            that.filePreviewInfo.ifLoad = false;
            that.$nextTick(function(){
                pageUtils.toPreviewFile(that,file,fieldone);
            })
        } else {
            // 可以增加下载权限的判断
            var url = that.GLOBAL.getFileServeUrl()+escape(file.downAddress);
            var flag = false;
            var name = file.name;
            console.log("name===============",name);
            var fileType = this.getFileTypeByName(file.downAddress);
            file.fileType = fileType;
            // 判断文件类型
            if(file.fileType == 'image') {
                // 图片类型
                flag = true;
            } else if(file.fileType == 'pdf') {
                // pdf类型
                flag = true;
            } else if(file.fileType == 'office') {
                //word excel ppt等类型
                flag = true;
                // window.open( "https://view.officeapps.live.com/op/view.aspx?src=" + url, "_blank" ); 
            } else if(file.fileType == 'video' || file.fileType == 'audio') {
                //音频 视频等类型
                window.open(url); 
            }  else {
                that.$message({
                message: '暂时不支持此文件类型的预览',
                type: 'warning'
                });
            }
            if(flag) {
                if(file.backGroundAudio) {
                    pageUtils.loadBackGroundAudio(that,file.backGroundAudio);
                }
                that.filePreviewInfo.ifLoad = true;
                that.filePreviewInfo.ifShow = true;
                that.filePreviewInfo.name = file.name;
                that.filePreviewInfo.fileOneInfo = file;

            }
        }
    },
    toVueExport:function(that,buttonOne){
        console.log("toVueExport--------------------------------",that.$refs.kw_card_default);
        let arr = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z"
        ];
        var styleJson = {};
        if(that.$refs.kw_card_default) {
            var kw_card_default = typeof(that.$refs.kw_card_default.length)=='number'?that.$refs.kw_card_default[0]:that.$refs.kw_card_default;
            if(kw_card_default) {
                var dataHavingList = kw_card_default.dataHavingList;
                var havinglength = dataHavingList.length;
                var dataList = kw_card_default.dataList;
                var listFieldSet = kw_card_default.listFieldSet;
                console.log("dataHavingList==============",dataHavingList);
                
                var headStyle = {
                    font:{
                        bold:true
                    },
                    alignment:{
                        horizontal:"center",
                        vertical:"center"
                    },
                    fill: { fgColor: { rgb: "999797"} }
                };
                var contentStyle = {
                    alignment:{
                        horizontal:"center",
                        vertical:"center",
                        wrapText: 1,
                        indent: 0
                    },
                    fill: { fgColor: { rgb: "ffffff" } }
                };
                var exportData = [];
                for (let index = 0; index <= ((havinglength-1)/4); index++) {
                    var dateArr = [];
                    var valueArr = [];
                    for (let havingIndex = 0; havingIndex < 4; havingIndex++) {
                        console.log("index*4+havingIndex==============",(index*4+havingIndex));
                        var havingValue = "";
                        var valueArrOne = "";
                        var valueBColor = "ffffff";
                        if(index*4+havingIndex < havinglength){
                            const havingOneInfo = dataHavingList[index*4+havingIndex];
                            if(havingOneInfo.havingFieldList) {
                                havingOneInfo.havingFieldList.forEach((havingFieldInfo)=>{
                                    havingValue += havingOneInfo.dataInfo[havingFieldInfo.fieldAliasName];
                                })
                            }
                            for (let dataIndex = havingOneInfo.minIndex; dataIndex < havingOneInfo.maxIndex; dataIndex++) {
                                var dataInfo = dataList[dataIndex];
                                if(listFieldSet) {
                                    listFieldSet.forEach((dataFieldInfo)=>{
                                        if(!dataFieldInfo.styleSet || (dataFieldInfo.styleSet.cssStyle!=5 && dataFieldInfo.styleSet.isHavingField!=1)) {
                                            valueArrOne += dataInfo[dataFieldInfo.fieldAliasName] + " ";
                                        }
                                    })
                                }
                                var zdyCss = kw_card_default.styleSetCodeZdy(kw_card_default.pageSetInfo.listStyleSet.listPageCardRightStyleSet,dataInfo);
                                
                                if(zdyCss) {
                                    if(zdyCss.indexOf("background-color:")>=0){
                                        var tmp = zdyCss.split("background-color:")[1];
                                        valueBColor = tmp.substring(0,tmp.indexOf(";")).trim();
                                        console.log("zdyCss=================",zdyCss,tmp,valueBColor);
                                        if(!valueBColor) {
                                            valueBColor = "ffffff";
                                        }
                                    }
                                }
                            }
                        }
                        console.log("valueBColor====================",index,havingIndex, valueBColor);
                        styleJson[arr[havingIndex]+((index*2)+1)] = headStyle;
                        var tmpcontentStyle = JSON.parse(JSON.stringify(contentStyle));
                        tmpcontentStyle.fill.fgColor.rgb = valueBColor.replace("#","");
                        styleJson[arr[havingIndex]+((index*2)+2)] = tmpcontentStyle;
                        dateArr.push(havingValue);
                        valueArr.push(valueArrOne);
                    }
                    exportData.push(dateArr);
                    exportData.push(valueArr);
                }
                console.log("styleJson=======================",styleJson);
                console.log("exportData=======================",exportData);
                require.ensure([], () => {
                    const { export_json_to_excel } = require("../../vendor/Export2Excel");
                    export_json_to_excel(null, exportData, buttonOne.buttonName,styleJson);
                });
            }
        } else if(that.$refs.kw_list_default) {
            var kw_list_default = typeof(that.$refs.kw_list_default.length)=='number'?that.$refs.kw_list_default[0]:that.$refs.kw_list_default;
            console.log("kw_list_default=================================================",kw_list_default);
            if(kw_list_default) {
                var tableData = kw_list_default.dataList;
                var tableDataSize = tableData.length;
                var tableTitleData = kw_list_default.listFieldSet;
                let allColumns = tableTitleData;
                var columnNames = [];
                var columnValues = [];
                var headStyle = {
                    font:{
                        bold:true
                    },
                    alignment:{
                        horizontal:"center",
                        vertical:"center"
                    },
                    fill: { fgColor: { rgb: "999797"} },
                    border:{
                        bottom:{
                            style:"thin"
                        },
                        left:{
                            style:"thin"
                        },
                        right:{
                            style:"thin"
                        },
                        top:{
                            style:"thin"
                        },
                    }
                };
                var contentStyle = {
                    alignment:{
                        horizontal:"center",
                        vertical:"center",
                        wrapText: 1,
                        indent: 0
                    },
                    fill: { fgColor: { rgb: "ffffff" } },
                    border:{
                        bottom:{
                            style:"thin"
                        },
                        left:{
                            style:"thin"
                        },
                        right:{
                            style:"thin"
                        },
                        top:{
                            style:"thin"
                        },
                    }
                };
                for (var i = 0; i < allColumns.length; i++) {
                  columnNames[i] = allColumns[i].fieldCnName;
                  columnValues[i] = allColumns[i].fieldAliasName;
                  styleJson[arr[i]+(1)] = headStyle;
                  for (var j = 0; j < tableDataSize; j++) {
                    var rowData = tableData[j];
                    var tmpcontentStyle = JSON.parse(JSON.stringify(contentStyle));
                    if(allColumns[i].styleSet && allColumns[i].styleSet.exportFieldJs) {
                        console.log("allColumns[i].styleSet.exportFieldJs=========1============",allColumns[i].styleSet);
                        eval(allColumns[i].styleSet.exportFieldJs);
                        console.log("allColumns[i].styleSet.exportFieldJs=========2============",tmpcontentStyle);
                    }
                    styleJson[arr[i]+(j+2)] = tmpcontentStyle;
                  }
                }
                require.ensure([], () => {
                    const { export_json_to_excel } = require("../../vendor/Export2Excel");
                    const tHeader = columnNames;
                    const filterVal = columnValues;
        
                    const list = tableData;
                    const data = this.formatJson(filterVal, list);
                    console.log("data=====================",data,styleJson);
                    export_json_to_excel(tHeader, data, buttonOne.buttonName,styleJson);
                });
            }
        }
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]?v[j]:''));
    },
    /**
     * 加载 背景音频的播放
     * @param {} that 
     * @param {*} audioUrl 
     */
    loadBackGroundAudio:function(that,audioUrl){
        var backGroundAudioInfo = that.backGroundAudioInfo;
        if(!backGroundAudioInfo) {
            backGroundAudioInfo = that.$router.app.$children[0].backGroundAudioInfo;
        }
        if(backGroundAudioInfo) {
            backGroundAudioInfo.ifLoad = true;
            backGroundAudioInfo.audioUrl = audioUrl;
            backGroundAudioInfo.backGroundAudioPlayState = true;
        }
    },
    /**
     * 销毁 背景音频的播放
     * @param {}} that 
     */
    destoryBackGroundAudio:function(that){
        var backGroundAudioInfo = that.$router.app.$children[0].backGroundAudioInfo;
        if(backGroundAudioInfo) {
            backGroundAudioInfo.ifLoad = false;
            backGroundAudioInfo.audioUrl = '';
            backGroundAudioInfo.backGroundAudioPlayState = false;
        }
    },
    /**
     * 根据文件名称获取文件类型
     */
    getFileTypeByName:function(name) {
        var fileType = '';
        if(name.indexOf(".jpg") > 0 || name.indexOf(".png") > 0|| name.indexOf(".jpng") > 0|| name.indexOf(".jpeg") > 0) {
          fileType = "image";
        } else if(name.indexOf(".mp4") > 0 || name.indexOf(".m3u8") > 0 || name.indexOf(".flv") > 0) {
          fileType = "video";
        } else if(name.indexOf(".mp3") > 0) {
          fileType = "audio";
        } else if(name.indexOf("doc") > 0 || name.indexOf("xls") > 0 || name.indexOf("docx") > 0 || name.indexOf("xlsx") > 0 || name.indexOf("wps") > 0 || name.indexOf("ppt") > 0 || name.indexOf("pptx") > 0) {
          fileType = "office";
        } else if(name.indexOf("pdf") > 0) {
          fileType = "pdf";
        } else {
          fileType = "other";
        }
        return fileType;
    },
    addBlockField:function(that, blockOne){
        if(!that.value[blockOne.blockEnName]) {
            that.$set(that.value, blockOne.blockEnName, []);
        // this.value[blockOne.blockEnName] = [];
        }
        var addJson = {};
        blockOne.fieldArr.forEach(childFieldOne => {
            if(childFieldOne.type == 6) {
                //条件插件
                addJson[childFieldOne.enName] = {
                    nameStr:"",
                    resultStr:"",
                    tjPlugId:0
                };
            } else if(childFieldOne.type == 4 || childFieldOne.type == 17){
                //值插件
                addJson[childFieldOne.enName] = {
                    nameStr:"",
                    resultStr:"",
                    valuePlugId:0
                };
            } else if(childFieldOne.type == 8) {
                //对象字段
                addJson[childFieldOne.enName] = {
                    tableId:"",
                    tableCnName:""
                };
            } else {
                if(childFieldOne.defaultValue>0) {
                    addJson[childFieldOne.enName] = childFieldOne.defaultValue
                } else {
                    addJson[childFieldOne.enName] = null;
                }
            }
        });
        that.value[blockOne.blockEnName].push(addJson);
        console.log("blockOne=========================",blockOne,this.value);
        that.$forceUpdate();
    },
    flutterWebPageFinished:function(){
        console.log("vue中执行flutterWebPageFinished==================");
        try {
            _flutterWebPageFinished.postMessage("");
        } catch (error) {
        } 
    },
    /**
     * base64转为可post的二进制数据
     */
    dataURLtoBlob: function (dataurl) {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
        type: mime
        });
    },
    /**
     * 
     * @param {上传文件到后台服务器} imageData 
     */
    uploadFileToServlet:function(imageData,callback){
        var param = new FormData();
        param.append('upload', imageData);
        utils.request(that,{
            url: 'servlet/OmFileUploadServlet', //仅为示例，并非真实的接口地址
            data: param,
            success: function (res) {
                console.log("res==================",res);
                if(callback) {
                    var file = {};
                    callback(res.data,file);
                }
            }
        })
    },
    saveMapDrawingInfo:function(that){
        var toHtData = {};
        toHtData.tableName = 'MAP_DRAWING';
        var toHtJsonInfo = [];
        var valueInfo = that.valueInfo;
        var mapCenter = {};
        valueInfo.forEach(valueOne => {
            var path = [];
            console.log("valueInfo====================",valueInfo,valueOne.path);
            if(valueOne.path) {
            valueOne.path.forEach(one => {
                path.push({
                    "LONGITUDE":one.lng,
                    "LATITUDE":one.lat
                })
                mapCenter[0] = one.lng;
                mapCenter[1] = one.lat;
            });
            }
            toHtJsonInfo.push({
                "MD_NAME" : valueOne.MD_NAME,
                "ZD_DRAWING_TYPE" : valueOne.ZD_DRAWING_TYPE,
                "MD_RADIUS" : valueOne.MD_RADIUS,
                "MAP_CENTER_LNG":mapCenter[0],
                "MAP_CENTER_LAT":mapCenter[1],
                "MAP_DRAWING_POINT":path
            })
        })

        toHtData.jsonStr = JSON.stringify(toHtJsonInfo);
        console.log("jsonStr====================",toHtJsonInfo);
        var loading = that.$loading({
            lock: true,
            text: '保存数据中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        var url = "wxXcxSet_saveJsonInfoToDb.do";
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
            url: url, //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
                loading.close();
                console.log("res=======================",res);
                that.value.defaultCheckValue = res.data;
                that.closeMapDialog();
            },
            error:function(){
                loading.close();
                // 保存失败
                that.$message({
                    message: "服务器出现问题,请重试或者联系管理员",
                    type: 'error'
                });
            }
        })
    },
    styleSetCodeZdy(json,rowData,index) {
        if(json) {
            var styleSetCode = json.styleSetCode;
            if(json.zdyJs) {
                styleSetCode += eval(json.zdyJs);
            }
            // console.log("styleSetCode=========================",styleSetCode,index,json);
            return styleSetCode;
        } else {
            return "";
        }
    },
}

export default pageUtils;
